import * as i0 from '@angular/core';
import { EventEmitter, ViewChild, Output, Input, Component, ApplicationRef, createComponent, forwardRef, ViewEncapsulation, Pipe, Injectable, Optional, HostListener, HostBinding, NgModule, InjectionToken } from '@angular/core';
import * as i4 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormGroup, FormControl, Validators as Validators$1, ReactiveFormsModule } from '@angular/forms';
import { Subject, of, isObservable, fromEvent, asyncScheduler } from 'rxjs';
import { takeUntil, throttleTime } from 'rxjs/operators';
import { NgxEditorError, clamp, uniq, isNil } from 'ngx-editor/utils';
import { DOMSerializer, DOMParser, Fragment, Slice } from 'prosemirror-model';
import { schema } from 'ngx-editor/schema';
const _c0 = ["imgEl"];
const _c1 = a0 => ({
  "NgxEditor__Resizer--Active": a0
});
function ImageViewComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 4)(1, "span", 5);
    i0.ɵɵlistener("mousedown", function ImageViewComponent_span_1_Template_span_mousedown_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.startResizing($event, "left"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵlistener("mousedown", function ImageViewComponent_span_1_Template_span_mousedown_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.startResizing($event, "right"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵlistener("mousedown", function ImageViewComponent_span_1_Template_span_mousedown_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.startResizing($event, "left"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 8);
    i0.ɵɵlistener("mousedown", function ImageViewComponent_span_1_Template_span_mousedown_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.startResizing($event, "right"));
    });
    i0.ɵɵelementEnd()();
  }
}
const _c2 = ["ngxEditor"];
const _c3 = ["*"];
const _c4 = (a0, a1) => ({
  backgroundColor: a0,
  color: a1
});
const _c5 = a0 => ({
  "NgxEditor__Color--Active": a0
});
function ColorPickerComponent_div_4_div_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("mousedown", function ColorPickerComponent_div_4_div_1_button_1_Template_button_mousedown_0_listener($event) {
      const color_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onColorSelectMouseClick($event, color_r3));
    })("keydown.enter", function ColorPickerComponent_div_4_div_1_button_1_Template_button_keydown_enter_0_listener() {
      const color_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onColorSelectKeydown(color_r3));
    })("keydown.space", function ColorPickerComponent_div_4_div_1_button_1_Template_button_keydown_space_0_listener() {
      const color_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.onColorSelectKeydown(color_r3));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const color_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(3, _c4, color_r3, ctx_r3.getContrastYIQ(color_r3)))("title", color_r3)("ngClass", i0.ɵɵpureFunction1(6, _c5, ctx_r3.activeColors.includes(color_r3)));
  }
}
function ColorPickerComponent_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, ColorPickerComponent_div_4_div_1_button_1_Template, 1, 8, "button", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const colorGroup_r5 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", colorGroup_r5)("ngForTrackBy", ctx_r3.trackByIndex);
  }
}
function ColorPickerComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, ColorPickerComponent_div_4_div_1_Template, 2, 2, "div", 3);
    i0.ɵɵelementStart(2, "button", 4);
    i0.ɵɵlistener("mousedown", function ColorPickerComponent_div_4_Template_button_mousedown_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onRemoveMouseClick($event));
    })("keydown.enter", function ColorPickerComponent_div_4_Template_button_keydown_enter_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onRemoveKeydown());
    })("keydown.space", function ColorPickerComponent_div_4_Template_button_keydown_space_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onRemoveKeydown());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.presets)("ngForTrackBy", ctx_r3.trackByIndex);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r3.isActive);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, ctx_r3.getLabel("remove")), " ");
  }
}
const _c6 = (a0, a1) => ({
  "NgxEditor__Dropdown--Active": a0,
  "NgxEditor--Disabled": a1
});
function DropdownComponent_div_4_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("mousedown", function DropdownComponent_div_4_button_1_Template_button_mousedown_0_listener($event) {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropdownItemMouseClick($event, item_r2));
    })("keydown.enter", function DropdownComponent_div_4_button_1_Template_button_keydown_enter_0_listener($event) {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropdownItemKeydown($event, item_r2));
    })("keydown.space", function DropdownComponent_div_4_button_1_Template_button_keydown_space_0_listener($event) {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDropdownItemKeydown($event, item_r2));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c6, item_r2 === ctx_r2.activeItem, ctx_r2.disabledItems.includes(item_r2)))("ariaLabel", i0.ɵɵpipeBind1(1, 4, ctx_r2.getName(item_r2)));
    i0.ɵɵattribute("aria-selected", item_r2 === ctx_r2.activeItem);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, ctx_r2.getName(item_r2)), " ");
  }
}
function DropdownComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, DropdownComponent_div_4_button_1_Template, 4, 11, "button", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.items)("ngForTrackBy", ctx_r2.trackByIndex);
  }
}
function ImageComponent_div_4_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, (ctx_r1.src.errors == null ? null : ctx_r1.src.errors["pattern"]) && ctx_r1.getLabel("enterValidUrl")), " ");
  }
}
function ImageComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "form", 3);
    i0.ɵɵlistener("ngSubmit", function ImageComponent_div_4_Template_form_ngSubmit_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.insertLink($event));
    });
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "label", 6);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "input", 7);
    i0.ɵɵtemplate(8, ImageComponent_div_4_div_8_Template, 3, 3, "div", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 4)(10, "div", 5)(11, "label", 6);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "input", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 4)(16, "div", 5)(17, "label", 6);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "input", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "button", 11);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "async");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("htmlFor", ctx_r1.getId("image-popup-url"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 13, ctx_r1.getLabel("url")));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r1.getId("image-popup-url"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.src.touched && ctx_r1.src.invalid);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("htmlFor", ctx_r1.getId("image-popup-label"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 15, ctx_r1.getLabel("altText")));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r1.getId("image-popup-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("htmlFor", ctx_r1.getId("image-popup-title"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 17, ctx_r1.getLabel("title")));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r1.getId("image-popup-title"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r1.form.valid || !ctx_r1.form.dirty);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 19, ctx_r1.getLabel("insert")));
  }
}
function LinkComponent_div_4_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, (ctx_r1.href.errors == null ? null : ctx_r1.href.errors["pattern"]) && ctx_r1.getLabel("enterValidUrl")), " ");
  }
}
function LinkComponent_div_4_div_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.text.errors == null ? null : ctx_r1.text.errors["required"]) && "This is required", " ");
  }
}
function LinkComponent_div_4_div_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "label");
    i0.ɵɵelement(3, "input", 13);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 1, ctx_r1.getLabel("openInNewTab")), " ");
  }
}
function LinkComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "form", 3);
    i0.ɵɵlistener("ngSubmit", function LinkComponent_div_4_Template_form_ngSubmit_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.insertLink($event));
    });
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "label", 6);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "input", 7);
    i0.ɵɵtemplate(8, LinkComponent_div_4_div_8_Template, 3, 3, "div", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 4)(10, "div", 5)(11, "label", 6);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "input", 9);
    i0.ɵɵtemplate(15, LinkComponent_div_4_div_15_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, LinkComponent_div_4_div_16_Template, 6, 3, "div", 10);
    i0.ɵɵelementStart(17, "button", 11);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "async");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("htmlFor", ctx_r1.getId("link-popup-url"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 12, ctx_r1.getLabel("url")));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r1.getId("link-popup-url"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.href.touched && ctx_r1.href.invalid);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("htmlFor", ctx_r1.getId("link-popup-label"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 14, ctx_r1.getLabel("text")));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r1.getId("link-popup-label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.text.touched && ctx_r1.text.invalid);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.options.showOpenInNewTab);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r1.form.valid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 16, ctx_r1.getLabel("insert")));
  }
}
const _c7 = (a0, a1) => ({
  "NgxEditor--Disabled": a0,
  "NgxEditor__MenuBar--Reverse": a1
});
function NgxEditorMenuComponent_ng_container_1_ng_container_1_ngx_toggle_command_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-toggle-command", 7);
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.iconContainerClass);
    i0.ɵɵproperty("toolbarItem", item_r1);
  }
}
function NgxEditorMenuComponent_ng_container_1_ng_container_1_ngx_insert_command_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-insert-command", 7);
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.iconContainerClass);
    i0.ɵɵproperty("toolbarItem", item_r1);
  }
}
function NgxEditorMenuComponent_ng_container_1_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "ngx-link", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1.iconContainerClass);
    i0.ɵɵproperty("options", ctx_r1.getLinkOptions(item_r1));
  }
}
function NgxEditorMenuComponent_ng_container_1_ng_container_1_ngx_image_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-image");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.iconContainerClass);
  }
}
function NgxEditorMenuComponent_ng_container_1_ng_container_1_ng_container_5_ngx_dropdown_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-dropdown", 10);
  }
  if (rf & 2) {
    const dropdownItem_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap(ctx_r1.dropdownContainerClass);
    i0.ɵɵproperty("group", dropdownItem_r3.key)("items", dropdownItem_r3.value);
  }
}
function NgxEditorMenuComponent_ng_container_1_ng_container_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NgxEditorMenuComponent_ng_container_1_ng_container_1_ng_container_5_ngx_dropdown_1_Template, 1, 4, "ngx-dropdown", 9);
    i0.ɵɵpipe(2, "keyvalue");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 2, ctx_r1.getDropdownItems(item_r1)))("ngForTrackBy", ctx_r1.trackByIndex);
  }
}
function NgxEditorMenuComponent_ng_container_1_ng_container_1_ngx_color_picker_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-color-picker", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.iconContainerClass);
    i0.ɵɵproperty("presets", ctx_r1.presets);
  }
}
function NgxEditorMenuComponent_ng_container_1_ng_container_1_ngx_color_picker_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-color-picker", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.iconContainerClass);
    i0.ɵɵproperty("presets", ctx_r1.presets);
  }
}
function NgxEditorMenuComponent_ng_container_1_ng_container_1_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.seperatorClass);
  }
}
function NgxEditorMenuComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NgxEditorMenuComponent_ng_container_1_ng_container_1_ngx_toggle_command_1_Template, 1, 3, "ngx-toggle-command", 3)(2, NgxEditorMenuComponent_ng_container_1_ng_container_1_ngx_insert_command_2_Template, 1, 3, "ngx-insert-command", 3)(3, NgxEditorMenuComponent_ng_container_1_ng_container_1_ng_container_3_Template, 2, 3, "ng-container", 2)(4, NgxEditorMenuComponent_ng_container_1_ng_container_1_ngx_image_4_Template, 1, 2, "ngx-image", 4)(5, NgxEditorMenuComponent_ng_container_1_ng_container_1_ng_container_5_Template, 3, 4, "ng-container", 2)(6, NgxEditorMenuComponent_ng_container_1_ng_container_1_ngx_color_picker_6_Template, 1, 3, "ngx-color-picker", 5)(7, NgxEditorMenuComponent_ng_container_1_ng_container_1_ngx_color_picker_7_Template, 1, 3, "ngx-color-picker", 6)(8, NgxEditorMenuComponent_ng_container_1_ng_container_1_div_8_Template, 1, 2, "div", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const lastItem_r4 = ctx.last;
    const lastToolbarItem_r5 = i0.ɵɵnextContext().last;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.toggleCommands.includes(item_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.insertCommands.includes(item_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isLinkItem(item_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1 === "image");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isDropDown(item_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1 === "text_color");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1 === "background_color");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", lastItem_r4 && !lastToolbarItem_r5);
  }
}
function NgxEditorMenuComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NgxEditorMenuComponent_ng_container_1_ng_container_1_Template, 9, 8, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const toolbarItem_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", toolbarItem_r6)("ngForTrackBy", ctx_r1.trackByIndex);
  }
}
function NgxEditorMenuComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customMenuRef);
  }
}
const _c8 = (a0, a1) => ({
  "NgxBubbleMenu__Icon--Active": a0,
  "NgxEditor--Disabled": a1
});
function BubbleComponent_ng_container_0_ng_container_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("mousedown", function BubbleComponent_ng_container_0_ng_container_1_button_1_Template_button_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClick($event, item_r2));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c8, ctx_r2.activeItems.includes(item_r2), !ctx_r2.execulableItems.includes(item_r2)))("title", i0.ɵɵpipeBind1(1, 3, ctx_r2.getTitle(item_r2)))("innerHTML", ctx_r2.getIcon(item_r2), i0.ɵɵsanitizeHtml);
  }
}
function BubbleComponent_ng_container_0_ng_container_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
  }
}
function BubbleComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BubbleComponent_ng_container_0_ng_container_1_button_1_Template, 2, 8, "button", 1)(2, BubbleComponent_ng_container_0_ng_container_1_div_2_Template, 1, 0, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const lastItem_r4 = ctx.last;
    const lastToolbarItem_r5 = i0.ɵɵnextContext().last;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.toggleCommands.includes(item_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", lastItem_r4 && !lastToolbarItem_r5);
  }
}
function BubbleComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BubbleComponent_ng_container_0_ng_container_1_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const toolbarItem_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", toolbarItem_r6)("ngForTrackBy", ctx_r2.trackByIndex);
  }
}
function NgxEditorFloatingMenuComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "ngx-bubble", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("editor", ctx_r0.editor);
  }
}
export { marks, nodes, schema } from 'ngx-editor/schema';
import { Plugin, PluginKey, NodeSelection, Selection, EditorState } from 'prosemirror-state';
import { DecorationSet, Decoration, EditorView } from 'prosemirror-view';
import * as i3 from '@angular/common';
import { CommonModule, AsyncPipe } from '@angular/common';
import * as i1 from '@angular/platform-browser';
import { toggleMark, lift, wrapIn, setBlockType, newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock, chainCommands, exitCode, baseKeymap } from 'prosemirror-commands';
import { applyMark, removeLink, removeMark } from 'ngx-editor/commands';
import { isMarkActive, isNodeActive, canInsert, getSelectionNodes, getSelectionMarks, markInputRule } from 'ngx-editor/helpers';
import { liftListItem, wrapInList, sinkListItem, splitListItem } from 'prosemirror-schema-list';
import { undo as undo$1, redo as redo$1, history } from 'prosemirror-history';
import { computePosition, offset, autoPlacement, detectOverflow } from '@floating-ui/dom';
import { keymap } from 'prosemirror-keymap';
import { wrappingInputRule, textblockTypeInputRule, smartQuotes, ellipsis, emDash, inputRules } from 'prosemirror-inputrules';
const isString = value => {
  return typeof value === 'string';
};
const getTrustedTypes = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.trustedTypes;
};
const isTrustedHtml = value => {
  return getTrustedTypes()?.isHTML(value) ?? false;
};
const isHtml = value => {
  return isString(value) || isTrustedHtml(value);
};
const emptyDoc = {
  type: 'doc',
  content: [{
    type: 'paragraph'
  }]
};
// https://developer.mozilla.org/en-US/docs/Web/API/DocumentFragment
const toHTML = (json, inputSchema) => {
  const schema$1 = inputSchema ?? schema;
  const contentNode = schema$1.nodeFromJSON(json);
  const html = DOMSerializer.fromSchema(schema$1).serializeFragment(contentNode.content);
  const div = document.createElement('div');
  div.appendChild(html);
  return div.innerHTML;
};
const toDoc = (html, inputSchema, options) => {
  const schema$1 = inputSchema ?? schema;
  const el = document.createElement('div');
  el.innerHTML = html;
  return DOMParser.fromSchema(schema$1).parse(el, options).toJSON();
};
const parseContent = (value, schema, options) => {
  if (!value) {
    return schema.nodeFromJSON(emptyDoc);
  }
  if (!isHtml(value)) {
    return schema.nodeFromJSON(value);
  }
  const docJson = toDoc(value, schema, options);
  return schema.nodeFromJSON(docJson);
};
const editablePlugin = (editable = true) => {
  return new Plugin({
    key: new PluginKey('editable'),
    state: {
      init() {
        return editable;
      },
      apply(tr, previousVal) {
        return tr.getMeta('UPDATE_EDITABLE') ?? previousVal;
      }
    },
    props: {
      editable(state) {
        return this.getState(state);
      },
      attributes(state) {
        const isEnabled = this.getState(state);
        if (isEnabled) {
          return null;
        }
        return {
          class: 'NgxEditor__Content--Disabled'
        };
      }
    }
  });
};
const PLACEHOLDER_CLASSNAME = 'NgxEditor__Placeholder';
const placeholderPlugin = text => {
  return new Plugin({
    key: new PluginKey('placeholder'),
    state: {
      init() {
        return text ?? '';
      },
      apply(tr, previousVal) {
        const placeholder = tr.getMeta('UPDATE_PLACEHOLDER') ?? previousVal;
        return placeholder;
      }
    },
    props: {
      decorations(state) {
        const {
          doc
        } = state;
        const {
          textContent,
          childCount
        } = doc;
        const placeholder = this.getState(state);
        if (!placeholder || childCount > 1) {
          return DecorationSet.empty;
        }
        const decorations = [];
        const decorate = (node, pos) => {
          if (node.type.isBlock && node.childCount === 0 && textContent.length === 0) {
            const from = pos;
            const to = pos + node.nodeSize;
            const placeholderNode = Decoration.node(from, to, {
              'class': PLACEHOLDER_CLASSNAME,
              'data-placeholder': placeholder,
              'data-align': node.attrs['align'] ?? null
            });
            decorations.push(placeholderNode);
          }
          return false;
        };
        doc.descendants(decorate);
        return DecorationSet.create(doc, decorations);
      }
    }
  });
};
const attributesPlugin = (attributes = {}) => {
  return new Plugin({
    key: new PluginKey('attributes'),
    props: {
      attributes
    }
  });
};
const focusPlugin = cb => {
  return new Plugin({
    key: new PluginKey('focus'),
    props: {
      handleDOMEvents: {
        focus: () => {
          cb();
          return false;
        }
      }
    }
  });
};
const blurPlugin = cb => {
  return new Plugin({
    key: new PluginKey('blur'),
    props: {
      handleDOMEvents: {
        blur: () => {
          cb();
          return false;
        }
      }
    }
  });
};
class ImageViewComponent {
  src;
  alt = '';
  title = '';
  outerWidth = '';
  selected = false;
  view;
  imageResize = new EventEmitter();
  imgEl;
  startResizing(e, direction) {
    e.preventDefault();
    this.resizeImage(e, direction);
  }
  resizeImage(evt, direction) {
    const startX = evt.pageX;
    const startWidth = this.imgEl.nativeElement.clientWidth;
    const isLeftResize = direction === 'left';
    const {
      width
    } = window.getComputedStyle(this.view.dom);
    const editorWidth = parseInt(width, 10);
    const onMouseMove = e => {
      const currentX = e.pageX;
      const diffInPx = currentX - startX;
      const computedWidth = isLeftResize ? startWidth - diffInPx : startWidth + diffInPx;
      // prevent image overflow the editor
      // prevent resizng below 20px
      if (computedWidth > editorWidth || computedWidth < 20) {
        return;
      }
      this.outerWidth = `${computedWidth}px`;
    };
    const onMouseUp = e => {
      e.preventDefault();
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      this.imageResize.emit();
    };
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }
  static ɵfac = function ImageViewComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ImageViewComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ImageViewComponent,
    selectors: [["ngx-image-view"]],
    viewQuery: function ImageViewComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.imgEl = _t.first);
      }
    },
    inputs: {
      src: "src",
      alt: "alt",
      title: "title",
      outerWidth: "outerWidth",
      selected: "selected",
      view: "view"
    },
    outputs: {
      imageResize: "imageResize"
    },
    decls: 4,
    vars: 9,
    consts: [["imgEl", ""], [1, "NgxEditor__ImageWrapper", 3, "ngClass"], ["class", "NgxEditor__ResizeHandle", 4, "ngIf"], [3, "src", "alt", "title"], [1, "NgxEditor__ResizeHandle"], [1, "NgxEditor__ResizeHandle--TL", 3, "mousedown"], [1, "NgxEditor__ResizeHandle--TR", 3, "mousedown"], [1, "NgxEditor__ResizeHandle--BL", 3, "mousedown"], [1, "NgxEditor__ResizeHandle--BR", 3, "mousedown"]],
    template: function ImageViewComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "span", 1);
        i0.ɵɵtemplate(1, ImageViewComponent_span_1_Template, 5, 0, "span", 2);
        i0.ɵɵelement(2, "img", 3, 0);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵstyleProp("width", ctx.outerWidth);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1, ctx.selected));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selected);
        i0.ɵɵadvance();
        i0.ɵɵproperty("src", ctx.src, i0.ɵɵsanitizeUrl)("alt", ctx.alt)("title", ctx.title);
      }
    },
    dependencies: [CommonModule, i3.NgClass, i3.NgIf],
    styles: ["*[_ngcontent-%COMP%], *[_ngcontent-%COMP%]:before, *[_ngcontent-%COMP%]:after{box-sizing:border-box}img[_ngcontent-%COMP%]{width:100%;height:100%}.NgxEditor__ImageWrapper[_ngcontent-%COMP%]{position:relative;display:inline-block;line-height:0;padding:2px}.NgxEditor__ImageWrapper.NgxEditor__Resizer--Active[_ngcontent-%COMP%]{padding:1px;border:1px solid #1a73e8}.NgxEditor__ImageWrapper[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle[_ngcontent-%COMP%]{position:absolute;height:100%;width:100%}.NgxEditor__ImageWrapper[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle--TL[_ngcontent-%COMP%], .NgxEditor__ImageWrapper[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle--BL[_ngcontent-%COMP%], .NgxEditor__ImageWrapper[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle--TR[_ngcontent-%COMP%], .NgxEditor__ImageWrapper[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle--BR[_ngcontent-%COMP%]{position:absolute;width:7px;height:7px;background-color:#1a73e8;border:1px solid white}.NgxEditor__ImageWrapper[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle--BR[_ngcontent-%COMP%]{bottom:-5px;right:-5px;cursor:se-resize}.NgxEditor__ImageWrapper[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle--TR[_ngcontent-%COMP%]{top:-5px;right:-5px;cursor:ne-resize}.NgxEditor__ImageWrapper[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle--TL[_ngcontent-%COMP%]{top:-5px;left:-5px;cursor:nw-resize}.NgxEditor__ImageWrapper[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle[_ngcontent-%COMP%]   .NgxEditor__ResizeHandle--BL[_ngcontent-%COMP%]{bottom:-5px;left:-5px;cursor:sw-resize}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageViewComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-image-view',
      imports: [CommonModule],
      template: "<span class=\"NgxEditor__ImageWrapper\" [ngClass]=\"{ 'NgxEditor__Resizer--Active': selected }\" [style.width]=\"outerWidth\">\n  <span class=\"NgxEditor__ResizeHandle\" *ngIf=\"selected\">\n    <span class=\"NgxEditor__ResizeHandle--TL\" (mousedown)=\"startResizing($event, 'left')\"></span>\n    <span class=\"NgxEditor__ResizeHandle--TR\" (mousedown)=\"startResizing($event, 'right')\"></span>\n    <span class=\"NgxEditor__ResizeHandle--BL\" (mousedown)=\"startResizing($event, 'left')\"></span>\n    <span class=\"NgxEditor__ResizeHandle--BR\" (mousedown)=\"startResizing($event, 'right')\"></span>\n  </span>\n  <img [src]=\"src\" [alt]=\"alt\" [title]=\"title\" #imgEl />\n</span>\n",
      styles: ["*,*:before,*:after{box-sizing:border-box}img{width:100%;height:100%}.NgxEditor__ImageWrapper{position:relative;display:inline-block;line-height:0;padding:2px}.NgxEditor__ImageWrapper.NgxEditor__Resizer--Active{padding:1px;border:1px solid #1a73e8}.NgxEditor__ImageWrapper .NgxEditor__ResizeHandle{position:absolute;height:100%;width:100%}.NgxEditor__ImageWrapper .NgxEditor__ResizeHandle .NgxEditor__ResizeHandle--TL,.NgxEditor__ImageWrapper .NgxEditor__ResizeHandle .NgxEditor__ResizeHandle--BL,.NgxEditor__ImageWrapper .NgxEditor__ResizeHandle .NgxEditor__ResizeHandle--TR,.NgxEditor__ImageWrapper .NgxEditor__ResizeHandle .NgxEditor__ResizeHandle--BR{position:absolute;width:7px;height:7px;background-color:#1a73e8;border:1px solid white}.NgxEditor__ImageWrapper .NgxEditor__ResizeHandle .NgxEditor__ResizeHandle--BR{bottom:-5px;right:-5px;cursor:se-resize}.NgxEditor__ImageWrapper .NgxEditor__ResizeHandle .NgxEditor__ResizeHandle--TR{top:-5px;right:-5px;cursor:ne-resize}.NgxEditor__ImageWrapper .NgxEditor__ResizeHandle .NgxEditor__ResizeHandle--TL{top:-5px;left:-5px;cursor:nw-resize}.NgxEditor__ImageWrapper .NgxEditor__ResizeHandle .NgxEditor__ResizeHandle--BL{bottom:-5px;left:-5px;cursor:sw-resize}\n"]
    }]
  }], null, {
    src: [{
      type: Input
    }],
    alt: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    outerWidth: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    view: [{
      type: Input
    }],
    imageResize: [{
      type: Output
    }],
    imgEl: [{
      type: ViewChild,
      args: ['imgEl', {
        static: true
      }]
    }]
  });
})();
class ImageRezieView {
  dom;
  view;
  getPos;
  applicationRef;
  imageComponentRef;
  resizeSubscription;
  node;
  updating = false;
  constructor(node, view, getPos, injector) {
    this.applicationRef = injector.get(ApplicationRef);
    // create component ref
    this.imageComponentRef = createComponent(ImageViewComponent, {
      environmentInjector: this.applicationRef.injector
    });
    // Attach to the view so that the change detector knows to run
    this.applicationRef.attachView(this.imageComponentRef.hostView);
    this.setNodeAttributes(node.attrs);
    this.imageComponentRef.instance.view = view;
    this.dom = this.imageComponentRef.location.nativeElement;
    this.view = view;
    this.node = node;
    this.getPos = getPos;
    this.resizeSubscription = this.imageComponentRef.instance.imageResize.subscribe(() => {
      this.handleResize();
    });
  }
  computeChanges(prevAttrs, newAttrs) {
    return JSON.stringify(prevAttrs) === JSON.stringify(newAttrs);
  }
  setNodeAttributes(attrs) {
    this.imageComponentRef.instance.src = attrs['src'];
    this.imageComponentRef.instance.alt = attrs['alt'];
    this.imageComponentRef.instance.title = attrs['title'];
    this.imageComponentRef.instance.outerWidth = attrs['width'];
  }
  handleResize = () => {
    if (this.updating) {
      return;
    }
    const {
      state,
      dispatch
    } = this.view;
    const {
      tr
    } = state;
    const transaction = tr.setNodeMarkup(this.getPos(), undefined, {
      ...this.node.attrs,
      width: this.imageComponentRef.instance.outerWidth
    });
    const resolvedPos = transaction.doc.resolve(this.getPos());
    const newSelection = new NodeSelection(resolvedPos);
    transaction.setSelection(newSelection);
    dispatch(transaction);
  };
  update(node) {
    if (node.type !== this.node.type) {
      return false;
    }
    this.node = node;
    const changed = this.computeChanges(this.node.attrs, node.attrs);
    if (changed) {
      this.updating = true;
      this.setNodeAttributes(node.attrs);
      this.updating = false;
    }
    return true;
  }
  ignoreMutation() {
    return true;
  }
  selectNode() {
    this.imageComponentRef.instance.selected = true;
  }
  deselectNode() {
    this.imageComponentRef.instance.selected = false;
  }
  destroy() {
    this.resizeSubscription.unsubscribe();
    this.applicationRef.detachView(this.imageComponentRef.hostView);
  }
}
const imageResizePlugin = injector => {
  return new Plugin({
    key: new PluginKey('image-resize'),
    props: {
      nodeViews: {
        image: (node, view, getPos) => {
          return new ImageRezieView(node, view, getPos, injector);
        }
      }
    }
  });
};
const HTTP_LINK_REGEX = /(?:https?:\/\/)?[\w-]+(?:\.[\w-]+)+\.?(?:\d+)?(?:\/\S*)?$/;
const linkify = fragment => {
  const linkified = [];
  fragment.forEach(child => {
    if (child.isText) {
      const text = child.text;
      let pos = 0;
      const match = HTTP_LINK_REGEX.exec(text);
      if (match) {
        const start = match.index;
        const end = start + match[0].length;
        const {
          link
        } = child.type.schema.marks;
        if (start > 0) {
          linkified.push(child.cut(pos, start));
        }
        const urlText = text.slice(start, end);
        linkified.push(child.cut(start, end).mark(link.create({
          href: urlText
        }).addToSet(child.marks)));
        pos = end;
      }
      if (pos < text.length) {
        linkified.push(child.cut(pos));
      }
    } else {
      linkified.push(child.copy(linkify(child.content)));
    }
  });
  return Fragment.fromArray(linkified);
};
const linkifyPlugin = () => {
  return new Plugin({
    key: new PluginKey('linkify'),
    props: {
      transformPasted: slice => {
        return new Slice(linkify(slice.content), slice.openStart, slice.openEnd);
      }
    }
  });
};
class NgxEditorComponent {
  renderer;
  injector;
  elementRef;
  constructor(renderer, injector, elementRef) {
    this.renderer = renderer;
    this.injector = injector;
    this.elementRef = elementRef;
  }
  ngxEditor;
  editor;
  outputFormat;
  placeholder = 'Type Here...';
  focusOut = new EventEmitter();
  focusIn = new EventEmitter();
  unsubscribe = new Subject();
  onChange = () => {};
  onTouched = () => {};
  writeValue(value) {
    if (!this.outputFormat && isHtml(value)) {
      this.outputFormat = 'html';
    }
    this.editor.setContent(value ?? emptyDoc);
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.setMeta('UPDATE_EDITABLE', !isDisabled);
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }
  handleChange(jsonDoc) {
    if (this.outputFormat === 'html') {
      const html = toHTML(jsonDoc, this.editor.schema);
      this.onChange(html);
      return;
    }
    this.onChange(jsonDoc);
  }
  setMeta(key, value) {
    const {
      dispatch,
      state: {
        tr
      }
    } = this.editor.view;
    dispatch(tr.setMeta(key, value));
  }
  setPlaceholder(placeholder) {
    this.setMeta('UPDATE_PLACEHOLDER', placeholder);
  }
  registerPlugins() {
    this.editor.registerPlugin(editablePlugin());
    this.editor.registerPlugin(placeholderPlugin(this.placeholder));
    this.editor.registerPlugin(attributesPlugin({
      class: 'NgxEditor__Content'
    }));
    this.editor.registerPlugin(focusPlugin(() => {
      this.focusIn.emit();
    }));
    this.editor.registerPlugin(blurPlugin(() => {
      this.focusOut.emit();
      this.onTouched();
    }));
    if (this.editor.features.resizeImage) {
      this.editor.registerPlugin(imageResizePlugin(this.injector));
    }
    if (this.editor.features.linkOnPaste) {
      this.editor.registerPlugin(linkifyPlugin());
    }
  }
  ngOnInit() {
    if (!this.editor) {
      throw new NgxEditorError('Required editor instance for initializing editor component');
    }
    this.registerPlugins();
    this.renderer.appendChild(this.ngxEditor.nativeElement, this.editor.view.dom);
    this.editor.valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(jsonDoc => {
      this.handleChange(jsonDoc);
    });
  }
  ngOnChanges(changes) {
    if (changes['placeholder'] && !changes['placeholder'].isFirstChange()) {
      this.setPlaceholder(changes['placeholder'].currentValue);
    }
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  static ɵfac = function NgxEditorComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxEditorComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NgxEditorComponent,
    selectors: [["ngx-editor"]],
    viewQuery: function NgxEditorComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c2, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngxEditor = _t.first);
      }
    },
    inputs: {
      editor: "editor",
      outputFormat: "outputFormat",
      placeholder: "placeholder"
    },
    outputs: {
      focusOut: "focusOut",
      focusIn: "focusIn"
    },
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgxEditorComponent),
      multi: true
    }]), i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c3,
    decls: 3,
    vars: 0,
    consts: [["ngxEditor", ""], [1, "NgxEditor"]],
    template: function NgxEditorComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵdomElementStart(0, "div", 1, 0);
        i0.ɵɵprojection(2);
        i0.ɵɵdomElementEnd();
      }
    },
    styles: [":root{--ngx-editor-border-radius: 4px;--ngx-editor-background-color: #fff;--ngx-editor-text-color: #000;--ngx-editor-placeholder-color: #6c757d;--ngx-editor-border-color: rgba(0, 0, 0, .2);--ngx-editor-wrapper-border-color: rgba(0, 0, 0, .2);--ngx-editor-menubar-bg-color: #fff;--ngx-editor-menubar-padding: 3px;--ngx-editor-menubar-height: 30px;--ngx-editor-blockquote-color: #ddd;--ngx-editor-blockquote-border-width: 3px;--ngx-editor-icon-size: 30px;--ngx-editor-popup-bg-color: #fff;--ngx-editor-popup-border-radius: 4px;--ngx-editor-popup-shadow: rgba(60, 64, 67, .15) 0px 2px 6px 2px;--ngx-editor-menu-item-border-radius: 2px;--ngx-editor-menu-item-active-color: #1a73e8;--ngx-editor-menu-item-hover-bg-color: #f1f1f1;--ngx-editor-menu-item-active-bg-color: #e8f0fe;--ngx-editor-seperator-color: #ccc;--ngx-editor-bubble-bg-color: #000;--ngx-editor-bubble-text-color: #fff;--ngx-editor-bubble-item-hover-color: #636262;--ngx-editor-bubble-seperator-color: #fff;--ngx-editor-focus-ring-color: #5e9ed6;--ngx-editor-error-color: red;--ngx-editor-click-pointer: default}.NgxEditor{background:var(--ngx-editor-background-color);color:var(--ngx-editor-text-color);background-clip:padding-box;border-radius:var(--ngx-editor-border-radius);border:1px solid var(--ngx-editor-border-color);position:relative}.NgxEditor--Disabled{opacity:.5!important;pointer-events:none!important}.NgxEditor__Placeholder:before{color:var(--ngx-editor-placeholder-color);opacity:1;-webkit-user-select:none;user-select:none;position:absolute;cursor:text;content:attr(data-placeholder)}.NgxEditor__Placeholder[data-align=right]:before{position:relative}.NgxEditor__Content{padding:8px;white-space:pre-wrap;outline:none;font-variant-ligatures:none;font-feature-settings:\"liga\" 0}.NgxEditor__Content p{margin:0 0 10px}.NgxEditor__Content blockquote{padding-left:16px;border-left:var(--ngx-editor-blockquote-border-width) solid var(--ngx-editor-blockquote-color);margin-left:0;margin-right:0}.NgxEditor__Content--Disabled{-webkit-user-select:none;user-select:none;pointer-events:none}.NgxEditor__Wrapper{border:1px solid var(--ngx-editor-wrapper-border-color);border-radius:var(--ngx-editor-border-radius)}.NgxEditor__Wrapper .NgxEditor__MenuBar{border-top-left-radius:var(--ngx-editor-border-radius);border-top-right-radius:var(--ngx-editor-border-radius);border-bottom:1px solid var(--ngx-editor-border-color)}.NgxEditor__Wrapper .NgxEditor{border-top-left-radius:0;border-top-right-radius:0;border:none}.NgxEditor__MenuBar{display:flex;flex-wrap:wrap;padding:var(--ngx-editor-menubar-padding);background-color:var(--ngx-editor-menubar-bg-color);gap:.25rem .1rem}.NgxEditor__MenuBar button:not(:disabled),.NgxEditor__MenuBar [role=button]:not(:disabled){cursor:var(--ngx-editor-click-pointer, default)}.NgxEditor__MenuItem{display:flex;align-items:center;justify-content:center;position:relative;flex-shrink:0}.NgxEditor__MenuItem.NgxEditor__MenuItem--IconContainer{display:flex;align-items:center;justify-content:center}.NgxEditor__MenuItem .NgxEditor__MenuItem--Icon{all:unset;appearance:none;height:var(--ngx-editor-icon-size);width:var(--ngx-editor-icon-size);transition:.2s ease-in-out;display:inline-flex;align-items:center;justify-content:center;border-radius:var(--ngx-editor-menu-item-border-radius)}.NgxEditor__MenuItem .NgxEditor__MenuItem--Icon+.NgxEditor__MenuItem--Icon{margin-left:2px}.NgxEditor__MenuItem .NgxEditor__MenuItem--Icon:focus-visible{outline:1px solid var(--ngx-editor-focus-ring-color)}.NgxEditor__MenuItem .NgxEditor__MenuItem--Icon:hover{background-color:var(--ngx-editor-menu-item-hover-bg-color)}.NgxEditor__MenuItem.NgxEditor__MenuItem--Text{padding:0 5px}.NgxEditor__MenuItem.NgxEditor__MenuItem--Active,.NgxEditor__MenuItem .NgxEditor__MenuItem--Active{background-color:var(--ngx-editor-menu-item-active-bg-color);color:var(--ngx-editor-menu-item-active-color)}.NgxEditor__Dropdown{min-width:64px;position:relative;display:flex;align-items:center;flex-shrink:0}.NgxEditor__Dropdown:hover{background-color:var(--ngx-editor-menu-item-hover-bg-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Text{all:unset;appearance:none;display:flex;align-items:center;justify-content:center;padding:0 5px;height:100%;width:100%}.NgxEditor__Dropdown .NgxEditor__Dropdown--Text:focus-visible{outline:1px solid var(--ngx-editor-focus-ring-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Text:after{display:inline-block;content:\"\";margin-left:24px;vertical-align:4px;border-top:4px solid;border-right:4px solid transparent;border-bottom:0;border-left:4px solid transparent}.NgxEditor__Dropdown .NgxEditor__Dropdown--DropdownMenu{position:absolute;left:0;box-shadow:var(--ngx-editor-popup-shadow);border-radius:var(--ngx-editor-popup-border-radius);background-color:var(--ngx-editor-popup-bg-color);z-index:10;width:100%;top:calc(var(--ngx-editor-menubar-height) + 2px);display:flex;flex-direction:column}.NgxEditor__Dropdown .NgxEditor__Dropdown--Item{all:unset;appearance:none;padding:8px;white-space:nowrap;color:inherit}.NgxEditor__Dropdown .NgxEditor__Dropdown--Item:focus-visible{outline:1px solid var(--ngx-editor-focus-ring-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Item:hover{background-color:var(--ngx-editor-menu-item-hover-bg-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Selected,.NgxEditor__Dropdown .NgxEditor__Dropdown--Open{color:var(--ngx-editor-menu-item-active-color);background-color:var(--ngx-editor-menu-item-active-bg-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Active{background-color:var(--ngx-editor-menu-item-active-bg-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Active:hover{background-color:var(--ngx-editor-menu-item-hover-bg-color)}.NgxEditor__MenuBar--Reverse .NgxEditor__Dropdown--DropdownMenu{top:unset;bottom:calc(var(--ngx-editor-menubar-height) + 2px)}.NgxEditor__MenuBar--Reverse .NgxEditor__Dropdown--Text:after{transform:rotate(180deg)}.NgxEditor__MenuBar--Reverse .NgxEditor__Popup{top:unset;bottom:calc(var(--ngx-editor-menubar-height) + 2px)}.NgxEditor__Popup{position:absolute;top:calc(var(--ngx-editor-menubar-height) + 2px);box-shadow:var(--ngx-editor-popup-shadow);border-radius:var(--ngx-editor-popup-border-radius);background-color:var(--ngx-editor-popup-bg-color);z-index:10;min-width:192px;padding:8px}.NgxEditor__Popup .NgxEditor__Popup--FormGroup{margin-bottom:8px}.NgxEditor__Popup .NgxEditor__Popup--FormGroup label{margin-bottom:3px}.NgxEditor__Popup .NgxEditor__Popup--FormGroup input[type=text],.NgxEditor__Popup .NgxEditor__Popup--FormGroup input[type=url]{padding:2px 4px}.NgxEditor__Popup .NgxEditor__Popup--Col{display:flex;flex-direction:column;position:relative}.NgxEditor__Popup .NgxEditor__Popup--Label{font-size:85%}.NgxEditor__Seperator{border-left:1px solid var(--ngx-editor-seperator-color);margin:0 5px}.NgxEditor__HelpText{font-size:80%}.NgxEditor__HelpText.NgxEditor__HelpText--Error{color:var(--ngx-editor-error-color)}\n"],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxEditorComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-editor',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NgxEditorComponent),
        multi: true
      }],
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"NgxEditor\" #ngxEditor>\n  <ng-content></ng-content>\n</div>\n",
      styles: [":root{--ngx-editor-border-radius: 4px;--ngx-editor-background-color: #fff;--ngx-editor-text-color: #000;--ngx-editor-placeholder-color: #6c757d;--ngx-editor-border-color: rgba(0, 0, 0, .2);--ngx-editor-wrapper-border-color: rgba(0, 0, 0, .2);--ngx-editor-menubar-bg-color: #fff;--ngx-editor-menubar-padding: 3px;--ngx-editor-menubar-height: 30px;--ngx-editor-blockquote-color: #ddd;--ngx-editor-blockquote-border-width: 3px;--ngx-editor-icon-size: 30px;--ngx-editor-popup-bg-color: #fff;--ngx-editor-popup-border-radius: 4px;--ngx-editor-popup-shadow: rgba(60, 64, 67, .15) 0px 2px 6px 2px;--ngx-editor-menu-item-border-radius: 2px;--ngx-editor-menu-item-active-color: #1a73e8;--ngx-editor-menu-item-hover-bg-color: #f1f1f1;--ngx-editor-menu-item-active-bg-color: #e8f0fe;--ngx-editor-seperator-color: #ccc;--ngx-editor-bubble-bg-color: #000;--ngx-editor-bubble-text-color: #fff;--ngx-editor-bubble-item-hover-color: #636262;--ngx-editor-bubble-seperator-color: #fff;--ngx-editor-focus-ring-color: #5e9ed6;--ngx-editor-error-color: red;--ngx-editor-click-pointer: default}.NgxEditor{background:var(--ngx-editor-background-color);color:var(--ngx-editor-text-color);background-clip:padding-box;border-radius:var(--ngx-editor-border-radius);border:1px solid var(--ngx-editor-border-color);position:relative}.NgxEditor--Disabled{opacity:.5!important;pointer-events:none!important}.NgxEditor__Placeholder:before{color:var(--ngx-editor-placeholder-color);opacity:1;-webkit-user-select:none;user-select:none;position:absolute;cursor:text;content:attr(data-placeholder)}.NgxEditor__Placeholder[data-align=right]:before{position:relative}.NgxEditor__Content{padding:8px;white-space:pre-wrap;outline:none;font-variant-ligatures:none;font-feature-settings:\"liga\" 0}.NgxEditor__Content p{margin:0 0 10px}.NgxEditor__Content blockquote{padding-left:16px;border-left:var(--ngx-editor-blockquote-border-width) solid var(--ngx-editor-blockquote-color);margin-left:0;margin-right:0}.NgxEditor__Content--Disabled{-webkit-user-select:none;user-select:none;pointer-events:none}.NgxEditor__Wrapper{border:1px solid var(--ngx-editor-wrapper-border-color);border-radius:var(--ngx-editor-border-radius)}.NgxEditor__Wrapper .NgxEditor__MenuBar{border-top-left-radius:var(--ngx-editor-border-radius);border-top-right-radius:var(--ngx-editor-border-radius);border-bottom:1px solid var(--ngx-editor-border-color)}.NgxEditor__Wrapper .NgxEditor{border-top-left-radius:0;border-top-right-radius:0;border:none}.NgxEditor__MenuBar{display:flex;flex-wrap:wrap;padding:var(--ngx-editor-menubar-padding);background-color:var(--ngx-editor-menubar-bg-color);gap:.25rem .1rem}.NgxEditor__MenuBar button:not(:disabled),.NgxEditor__MenuBar [role=button]:not(:disabled){cursor:var(--ngx-editor-click-pointer, default)}.NgxEditor__MenuItem{display:flex;align-items:center;justify-content:center;position:relative;flex-shrink:0}.NgxEditor__MenuItem.NgxEditor__MenuItem--IconContainer{display:flex;align-items:center;justify-content:center}.NgxEditor__MenuItem .NgxEditor__MenuItem--Icon{all:unset;appearance:none;height:var(--ngx-editor-icon-size);width:var(--ngx-editor-icon-size);transition:.2s ease-in-out;display:inline-flex;align-items:center;justify-content:center;border-radius:var(--ngx-editor-menu-item-border-radius)}.NgxEditor__MenuItem .NgxEditor__MenuItem--Icon+.NgxEditor__MenuItem--Icon{margin-left:2px}.NgxEditor__MenuItem .NgxEditor__MenuItem--Icon:focus-visible{outline:1px solid var(--ngx-editor-focus-ring-color)}.NgxEditor__MenuItem .NgxEditor__MenuItem--Icon:hover{background-color:var(--ngx-editor-menu-item-hover-bg-color)}.NgxEditor__MenuItem.NgxEditor__MenuItem--Text{padding:0 5px}.NgxEditor__MenuItem.NgxEditor__MenuItem--Active,.NgxEditor__MenuItem .NgxEditor__MenuItem--Active{background-color:var(--ngx-editor-menu-item-active-bg-color);color:var(--ngx-editor-menu-item-active-color)}.NgxEditor__Dropdown{min-width:64px;position:relative;display:flex;align-items:center;flex-shrink:0}.NgxEditor__Dropdown:hover{background-color:var(--ngx-editor-menu-item-hover-bg-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Text{all:unset;appearance:none;display:flex;align-items:center;justify-content:center;padding:0 5px;height:100%;width:100%}.NgxEditor__Dropdown .NgxEditor__Dropdown--Text:focus-visible{outline:1px solid var(--ngx-editor-focus-ring-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Text:after{display:inline-block;content:\"\";margin-left:24px;vertical-align:4px;border-top:4px solid;border-right:4px solid transparent;border-bottom:0;border-left:4px solid transparent}.NgxEditor__Dropdown .NgxEditor__Dropdown--DropdownMenu{position:absolute;left:0;box-shadow:var(--ngx-editor-popup-shadow);border-radius:var(--ngx-editor-popup-border-radius);background-color:var(--ngx-editor-popup-bg-color);z-index:10;width:100%;top:calc(var(--ngx-editor-menubar-height) + 2px);display:flex;flex-direction:column}.NgxEditor__Dropdown .NgxEditor__Dropdown--Item{all:unset;appearance:none;padding:8px;white-space:nowrap;color:inherit}.NgxEditor__Dropdown .NgxEditor__Dropdown--Item:focus-visible{outline:1px solid var(--ngx-editor-focus-ring-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Item:hover{background-color:var(--ngx-editor-menu-item-hover-bg-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Selected,.NgxEditor__Dropdown .NgxEditor__Dropdown--Open{color:var(--ngx-editor-menu-item-active-color);background-color:var(--ngx-editor-menu-item-active-bg-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Active{background-color:var(--ngx-editor-menu-item-active-bg-color)}.NgxEditor__Dropdown .NgxEditor__Dropdown--Active:hover{background-color:var(--ngx-editor-menu-item-hover-bg-color)}.NgxEditor__MenuBar--Reverse .NgxEditor__Dropdown--DropdownMenu{top:unset;bottom:calc(var(--ngx-editor-menubar-height) + 2px)}.NgxEditor__MenuBar--Reverse .NgxEditor__Dropdown--Text:after{transform:rotate(180deg)}.NgxEditor__MenuBar--Reverse .NgxEditor__Popup{top:unset;bottom:calc(var(--ngx-editor-menubar-height) + 2px)}.NgxEditor__Popup{position:absolute;top:calc(var(--ngx-editor-menubar-height) + 2px);box-shadow:var(--ngx-editor-popup-shadow);border-radius:var(--ngx-editor-popup-border-radius);background-color:var(--ngx-editor-popup-bg-color);z-index:10;min-width:192px;padding:8px}.NgxEditor__Popup .NgxEditor__Popup--FormGroup{margin-bottom:8px}.NgxEditor__Popup .NgxEditor__Popup--FormGroup label{margin-bottom:3px}.NgxEditor__Popup .NgxEditor__Popup--FormGroup input[type=text],.NgxEditor__Popup .NgxEditor__Popup--FormGroup input[type=url]{padding:2px 4px}.NgxEditor__Popup .NgxEditor__Popup--Col{display:flex;flex-direction:column;position:relative}.NgxEditor__Popup .NgxEditor__Popup--Label{font-size:85%}.NgxEditor__Seperator{border-left:1px solid var(--ngx-editor-seperator-color);margin:0 5px}.NgxEditor__HelpText{font-size:80%}.NgxEditor__HelpText.NgxEditor__HelpText--Error{color:var(--ngx-editor-error-color)}\n"]
    }]
  }], () => [{
    type: i0.Renderer2
  }, {
    type: i0.Injector
  }, {
    type: i0.ElementRef
  }], {
    ngxEditor: [{
      type: ViewChild,
      args: ['ngxEditor', {
        static: true
      }]
    }],
    editor: [{
      type: Input
    }],
    outputFormat: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    focusOut: [{
      type: Output
    }],
    focusIn: [{
      type: Output
    }]
  });
})();
class SanitizeHtmlPipe {
  sanitizer;
  constructor(sanitizer) {
    this.sanitizer = sanitizer;
  }
  transform(value) {
    if (isTrustedHtml(value)) {
      return value;
    }
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
  static ɵfac = function SanitizeHtmlPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SanitizeHtmlPipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "sanitizeHtml",
    type: SanitizeHtmlPipe,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SanitizeHtmlPipe, [{
    type: Pipe,
    args: [{
      name: 'sanitizeHtml'
    }]
  }], () => [{
    type: i1.DomSanitizer
  }], null);
})();
class Mark {
  name;
  constructor(name) {
    this.name = name;
  }
  apply() {
    return (state, dispatch) => {
      const {
        schema
      } = state;
      const type = schema.marks[this.name];
      if (!type) {
        return false;
      }
      return applyMark(type)(state, dispatch);
    };
  }
  toggle() {
    return (state, dispatch) => {
      const {
        schema
      } = state;
      const type = schema.marks[this.name];
      if (!type) {
        return false;
      }
      return toggleMark(type)(state, dispatch);
    };
  }
  isActive(state) {
    const {
      schema
    } = state;
    const type = schema.marks[this.name];
    if (!type) {
      return false;
    }
    return isMarkActive(state, type);
  }
  canExecute(state) {
    return this.toggle()(state);
  }
}
class Blockqote {
  toggle() {
    return (state, dispatch) => {
      const {
        schema
      } = state;
      const type = schema.nodes['blockquote'];
      if (!type) {
        return false;
      }
      if (this.isActive(state)) {
        return lift(state, dispatch);
      }
      return wrapIn(type)(state, dispatch);
    };
  }
  isActive(state) {
    const {
      schema
    } = state;
    const type = schema.nodes['blockquote'];
    if (!type) {
      return false;
    }
    return isNodeActive(state, type);
  }
  canExecute(state) {
    return this.toggle()(state);
  }
}
class HorizontalRule {
  insert() {
    return (state, dispatch) => {
      const {
        schema,
        tr
      } = state;
      const type = schema.nodes['horizontal_rule'];
      if (!type) {
        return false;
      }
      dispatch(tr.replaceSelectionWith(type.create()).scrollIntoView());
      return true;
    };
  }
  canExecute(state) {
    return canInsert(state, state.schema.nodes['horizontal_rule']);
  }
}
class ListItem {
  isBulletList = false;
  constructor(isBulletList = false) {
    this.isBulletList = isBulletList;
  }
  getType(schema) {
    return this.isBulletList ? schema.nodes['bullet_list'] : schema.nodes['ordered_list'];
  }
  toggle() {
    return (state, dispatch) => {
      const {
        schema
      } = state;
      const type = this.getType(schema);
      if (!type) {
        return false;
      }
      if (this.isActive(state)) {
        return liftListItem(schema.nodes['list_item'])(state, dispatch);
      }
      return wrapInList(type)(state, dispatch);
    };
  }
  isActive(state) {
    const {
      schema
    } = state;
    const type = this.getType(schema);
    if (!type) {
      return false;
    }
    return isNodeActive(state, type);
  }
  canExecute(state) {
    return this.toggle()(state);
  }
}
class Heading {
  level;
  constructor(level) {
    this.level = level;
  }
  apply() {
    return (state, dispatch) => {
      const {
        schema
      } = state;
      const type = schema.nodes['heading'];
      if (!type) {
        return false;
      }
      return setBlockType(type)(state, dispatch);
    };
  }
  toggle() {
    return (state, dispatch) => {
      const {
        schema,
        selection,
        doc
      } = state;
      const type = schema.nodes['heading'];
      if (!type) {
        return false;
      }
      const nodePos = selection.$from.before(1);
      const node = doc.nodeAt(nodePos);
      const attrs = node?.attrs ?? {};
      if (this.isActive(state)) {
        return setBlockType(schema.nodes['paragraph'], attrs)(state, dispatch);
      }
      return setBlockType(type, {
        ...attrs,
        level: this.level
      })(state, dispatch);
    };
  }
  isActive(state) {
    const {
      schema
    } = state;
    const nodesInSelection = getSelectionNodes(state);
    const type = schema.nodes['heading'];
    if (!type) {
      return false;
    }
    const supportedNodes = [type, schema.nodes['text'], schema.nodes['blockquote']];
    // heading is a text node
    // don't mark as active when it has more nodes
    const nodes = nodesInSelection.filter(node => {
      return supportedNodes.includes(node.type);
    });
    const acitveNode = nodes.find(node => {
      return node.attrs['level'] === this.level;
    });
    return Boolean(acitveNode);
  }
  canExecute(state) {
    return this.toggle()(state);
  }
}
class TextAlign {
  align;
  constructor(align) {
    this.align = align;
  }
  toggle() {
    return (state, dispatch) => {
      const {
        doc,
        selection,
        tr,
        schema
      } = state;
      const {
        from,
        to
      } = selection;
      let applicable = false;
      doc.nodesBetween(from, to, (node, pos) => {
        const nodeType = node.type;
        if ([schema.nodes['paragraph'], schema.nodes['heading']].includes(nodeType)) {
          applicable = true;
          const align = node.attrs['align'] === this.align ? null : this.align;
          tr.setNodeMarkup(pos, nodeType, {
            ...node.attrs,
            align
          });
        }
        return true;
      });
      if (!applicable) {
        return false;
      }
      if (tr.docChanged) {
        dispatch?.(tr);
      }
      return true;
    };
  }
  isActive(state) {
    const nodes = getSelectionNodes(state);
    const active = nodes.find(node => {
      return node.attrs['align'] === this.align;
    });
    return Boolean(active);
  }
  canExecute(state) {
    return this.toggle()(state);
  }
}
const defaultOptions = {
  strict: true
};
let Link$1 = class Link {
  update(attrs) {
    return (state, dispatch) => {
      const {
        schema,
        selection
      } = state;
      const type = schema.marks['link'];
      if (!type) {
        return false;
      }
      if (selection.empty) {
        return false;
      }
      return toggleMark(type, attrs)(state, dispatch);
    };
  }
  insert(text, attrs) {
    return (state, dispatch) => {
      const {
        schema,
        tr
      } = state;
      const type = schema.marks['link'];
      if (!type) {
        return false;
      }
      const linkAttrs = {
        href: attrs.href,
        title: attrs.title ?? text,
        target: attrs.target ?? '_blank'
      };
      const node = schema.text(text, [schema.marks['link'].create(linkAttrs)]);
      tr.replaceSelectionWith(node, false).scrollIntoView();
      if (tr.docChanged) {
        dispatch?.(tr);
        return true;
      }
      return false;
    };
  }
  isActive(state, options = defaultOptions) {
    if (options.strict) {
      return true;
    }
    const {
      schema
    } = state;
    const type = schema.marks['link'];
    if (!type) {
      return false;
    }
    return isMarkActive(state, type);
  }
  remove(state, dispatch) {
    return removeLink()(state, dispatch);
  }
  canExecute(state) {
    const testAttrs = {
      href: ''
    };
    return this.insert('Exec', testAttrs)(state) || this.update(testAttrs)(state);
  }
};
let Image$1 = class Image {
  insert(src, attrs) {
    return (state, dispatch) => {
      const {
        schema,
        tr,
        selection
      } = state;
      const type = schema.nodes['image'];
      if (!type) {
        return false;
      }
      const imageAttrs = {
        width: null,
        src,
        ...attrs
      };
      if (!imageAttrs.width && selection instanceof NodeSelection && selection.node.type === type) {
        imageAttrs.width = selection.node.attrs['width'];
      }
      tr.replaceSelectionWith(type.createAndFill(imageAttrs));
      const resolvedPos = tr.doc.resolve(tr.selection.anchor - tr.selection.$anchor.nodeBefore.nodeSize);
      tr.setSelection(new NodeSelection(resolvedPos)).scrollIntoView();
      if (tr.docChanged) {
        dispatch?.(tr);
        return true;
      }
      return false;
    };
  }
  isActive(state) {
    const {
      selection
    } = state;
    if (selection instanceof NodeSelection) {
      return selection.node.type.name === 'image';
    }
    return false;
  }
};
let TextColor$1 = class TextColor {
  name;
  attrName;
  constructor(name, attrName = 'color') {
    this.name = name;
    this.attrName = attrName;
  }
  apply(attrs) {
    return (state, dispatch) => {
      const {
        schema,
        selection,
        doc
      } = state;
      const type = schema.marks[this.name];
      if (!type) {
        return false;
      }
      const {
        from,
        to,
        empty
      } = selection;
      if (!empty && from + 1 === to) {
        const node = doc.nodeAt(from);
        if (node?.isAtom && !node.isText && node.isLeaf) {
          // An atomic node (e.g. Image) is selected.
          return false;
        }
      }
      return applyMark(type, attrs)(state, dispatch);
    };
  }
  isActive(state) {
    const {
      schema
    } = state;
    const type = schema.marks[this.name];
    if (!type) {
      return false;
    }
    return isMarkActive(state, type);
  }
  getActiveColors(state) {
    if (!this.isActive(state)) {
      return [];
    }
    const {
      schema
    } = state;
    const marks = getSelectionMarks(state);
    const colors = marks.filter(mark => mark.type === schema.marks[this.name]).map(mark => {
      return mark.attrs[this.attrName];
    }).filter(Boolean);
    return colors;
  }
  remove() {
    return (state, dispatch) => {
      const {
        schema
      } = state;
      const type = schema.marks[this.name];
      if (!type) {
        return false;
      }
      return removeMark(type)(state, dispatch);
    };
  }
  canExecute(state) {
    const attrs = this.name === 'text_color' ? {
      color: ''
    } : {
      backgroundColor: ''
    };
    return this.apply(attrs)(state);
  }
};
const SAFE_MARKS = ['link'];
class FormatClear {
  insert() {
    return (state, dispatch) => {
      const {
        tr
      } = state;
      const {
        ranges,
        empty
      } = tr.selection;
      if (empty) {
        return true;
      }
      Object.entries(state.schema.marks).forEach(([markType, mark]) => {
        if (SAFE_MARKS.includes(markType)) {
          return;
        }
        ranges.forEach(range => {
          tr.removeMark(range.$from.pos, range.$to.pos, mark);
        });
      });
      dispatch(tr);
      return true;
    };
  }
  canExecute() {
    return true;
  }
}
const indentNodeTypes = ['paragraph', 'heading', 'blockquote'];
const minIndent = 0;
const maxIndent = 10;
const udpateIndentLevel = (tr, pos, method) => {
  const node = tr.doc.nodeAt(pos);
  if (!node) {
    return false;
  }
  const nodeIndent = node.attrs['indent'] ?? 0;
  const newIndent = clamp(nodeIndent + (method === 'increase' ? 1 : -1), minIndent, maxIndent);
  if (newIndent === nodeIndent || newIndent < minIndent || newIndent > maxIndent) {
    return false;
  }
  const attrs = {
    ...node.attrs,
    indent: newIndent
  };
  tr.setNodeMarkup(pos, node.type, attrs);
  return true;
};
class Indent {
  method = 'increase';
  constructor(method) {
    this.method = method;
  }
  insert() {
    return (state, dispatch) => {
      const {
        tr,
        doc
      } = state;
      const {
        from,
        to
      } = tr.selection;
      let applicable = false;
      doc.nodesBetween(from, to, (node, pos) => {
        const nodeType = node.type;
        if (indentNodeTypes.includes(nodeType.name)) {
          applicable = udpateIndentLevel(tr, pos, this.method);
          return false;
        } else if (node.type.name.includes('list')) {
          return false;
        }
        return true;
      });
      if (!applicable) {
        return false;
      }
      if (tr.docChanged) {
        dispatch?.(tr);
      }
      return true;
    };
  }
  canExecute(state) {
    return this.insert()(state);
  }
}
class History {
  mode = 'undo';
  constructor(mode) {
    this.mode = mode;
  }
  insert() {
    return (state, dispatch) => {
      if (this.mode === 'undo') {
        return undo$1(state, dispatch);
      }
      return redo$1(state, dispatch);
    };
  }
  canExecute(state) {
    return this.insert()(state);
  }
}
const STRONG = new Mark('strong');
const EM = new Mark('em');
const CODE = new Mark('code');
const UNDERLINE = new Mark('u');
const STRIKE = new Mark('s');
const BLOCKQUOTE = new Blockqote();
const HORIZONTAL_RULE = new HorizontalRule();
const FORMAT_CLEAR = new FormatClear();
const UL = new ListItem(true);
const OL = new ListItem(false);
const H1 = new Heading(1);
const H2 = new Heading(2);
const H3 = new Heading(3);
const H4 = new Heading(4);
const H5 = new Heading(5);
const H6 = new Heading(6);
const ALIGN_LEFT = new TextAlign('left');
const ALIGN_CENTER = new TextAlign('center');
const ALIGN_RIGHT = new TextAlign('right');
const ALIGN_JUSTIFY = new TextAlign('justify');
const LINK = new Link$1();
const IMAGE = new Image$1();
const TEXT_COLOR = new TextColor$1('text_color', 'color');
const TEXT_BACKGROUND_COLOR = new TextColor$1('text_background_color', 'backgroundColor');
const INDENT = new Indent('increase');
const OUTDENT = new Indent('decrease');
const SUPERSCRIPT = new Mark('sup');
const SUBSCRIPT = new Mark('sub');
const UNDO = new History('undo');
const REDO = new History('redo');
const ToggleCommands = {
  bold: STRONG,
  italic: EM,
  code: CODE,
  underline: UNDERLINE,
  strike: STRIKE,
  blockquote: BLOCKQUOTE,
  bullet_list: UL,
  ordered_list: OL,
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
  align_left: ALIGN_LEFT,
  align_center: ALIGN_CENTER,
  align_right: ALIGN_RIGHT,
  align_justify: ALIGN_JUSTIFY,
  superscript: SUPERSCRIPT,
  subscript: SUBSCRIPT
};
const InsertCommands = {
  horizontal_rule: HORIZONTAL_RULE,
  format_clear: FORMAT_CLEAR,
  indent: INDENT,
  outdent: OUTDENT,
  undo: UNDO,
  redo: REDO
};
const Link = LINK;
const Image = IMAGE;
const TextColor = TEXT_COLOR;
const TextBackgroundColor = TEXT_BACKGROUND_COLOR;
class MenuService {
  editor;
  customMenuRefChange = new Subject();
  setCustomMenuRef(c) {
    this.customMenuRefChange.next(c);
  }
  static ɵfac = function MenuService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MenuService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MenuService,
    factory: MenuService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
const defaults = {
  // menu
  bold: 'Bold',
  italic: 'Italic',
  code: 'Code',
  underline: 'Underline',
  strike: 'Strike',
  blockquote: 'Blockquote',
  bullet_list: 'Bullet List',
  ordered_list: 'Ordered List',
  heading: 'Heading',
  h1: 'Header 1',
  h2: 'Header 2',
  h3: 'Header 3',
  h4: 'Header 4',
  h5: 'Header 5',
  h6: 'Header 6',
  align_left: 'Left Align',
  align_center: 'Center Align',
  align_right: 'Right Align',
  align_justify: 'Justify',
  text_color: 'Text Color',
  background_color: 'Background Color',
  horizontal_rule: 'Horizontal rule',
  format_clear: 'Clear Formatting',
  insertLink: 'Insert Link',
  removeLink: 'Remove Link',
  insertImage: 'Insert Image',
  indent: 'Increase Indent',
  outdent: 'Decrease Indent',
  superscript: 'Superscript',
  subscript: 'Subscript',
  undo: 'Undo',
  redo: 'Redo',
  // pupups, forms, others...
  url: 'URL',
  text: 'Text',
  openInNewTab: 'Open in new tab',
  insert: 'Insert',
  altText: 'Alt Text',
  title: 'Title',
  remove: 'Remove',
  enterValidUrl: 'Please enter a valid URL'
};
class Locals {
  locals = defaults;
  constructor(newLocals = {}) {
    this.locals = {
      ...defaults,
      ...newLocals
    };
  }
  get = key => {
    const value = this.locals[key];
    if (value) {
      return isObservable(value) ? value : of(value);
    }
    return of('');
  };
}
var bold = `
  <path d="M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z" />
`;
var italic = `
  <path d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z" />
`;
var code = `
<path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
`;
var underline = `
<path d="M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"/>
`;
var strike = `
<path d="M6.85,7.08C6.85,4.37,9.45,3,12.24,3c1.64,0,3,0.49,3.9,1.28c0.77,0.65,1.46,1.73,1.46,3.24h-3.01 c0-0.31-0.05-0.59-0.15-0.85c-0.29-0.86-1.2-1.28-2.25-1.28c-1.86,0-2.34,1.02-2.34,1.7c0,0.48,0.25,0.88,0.74,1.21 C10.97,8.55,11.36,8.78,12,9H7.39C7.18,8.66,6.85,8.11,6.85,7.08z M21,12v-2H3v2h9.62c1.15,0.45,1.96,0.75,1.96,1.97 c0,1-0.81,1.67-2.28,1.67c-1.54,0-2.93-0.54-2.93-2.51H6.4c0,0.55,0.08,1.13,0.24,1.58c0.81,2.29,3.29,3.3,5.67,3.3 c2.27,0,5.3-0.89,5.3-4.05c0-0.3-0.01-1.16-0.48-1.94H21V12z"/>
`;
var orderedList = `
<path d="M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"/>
`;
var bulletList = `
<path d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"/>
`;
var quote = `
<path d="M0 0h24v24H0z" fill="none"/><path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"/>
`;
var link = `
<path d="M0 0h24v24H0z" fill="none"/><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/>
`;
var unlink = `
<path d="M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z"/>
`;
var image = `
<path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
`;
var alignLeft = `
<path d="M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"/>
`;
var alignCenter = `
<path d="M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"/>
`;
var alignRight = `
<path d="M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"/>
`;
var alignJustify = `
<path d="M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"/>
`;
var textColor = `
<path d="M2,20h20v4H2V20z M5.49,17h2.42l1.27-3.58h5.65L16.09,17h2.42L13.25,3h-2.5L5.49,17z M9.91,11.39l2.03-5.79h0.12l2.03,5.79 H9.91z"/>
`;
var colorFill = `
<path d="M16.56,8.94L7.62,0L6.21,1.41l2.38,2.38L3.44,8.94c-0.59,0.59-0.59,1.54,0,2.12l5.5,5.5C9.23,16.85,9.62,17,10,17 s0.77-0.15,1.06-0.44l5.5-5.5C17.15,10.48,17.15,9.53,16.56,8.94z M5.21,10L10,5.21L14.79,10H5.21z M19,11.5c0,0-2,2.17-2,3.5 c0,1.1,0.9,2,2,2s2-0.9,2-2C21,13.67,19,11.5,19,11.5z M2,20h20v4H2V20z"/>
`;
var horizontalRule = `
  <g>
    <rect fill="none" fill-rule="evenodd" height="24" width="24"/>
    <rect fill-rule="evenodd" height="2" width="16" x="4" y="11"/>
  </g>
`;
var formatClear = `
<path d="M0 0h24v24H0z" fill="none"/><path d="M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"/>
`;
var indent = '<path d="M0 0h24v24H0V0z" fill="none"/><path d="M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"/>';
var outdent = '<path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"/>';
var superscript = '<g><rect fill="none" height="20" width="20"/><path d="M17,6l-1,0v1h2v1l-3,0V6c0-0.55,0.45-1,1-1l1,0l0-1h-2V3l2,0c0.55,0,1,0.45,1,1v1C18,5.55,17.55,6,17,6z M5.63,16h1.9 l2.43-3.87h0.08L12.47,16h1.9l-3.32-5.2l3.1-4.8h-1.91l-2.19,3.56H9.96L7.75,6h-1.9l3.09,4.8L5.63,16z"/></g>';
var subscript = '<g><rect fill="none" height="20" width="20"/><path d="M17,15l-1,0v1h2v1h-3v-2c0-0.55,0.45-1,1-1l1,0l0-1h-2v-1l2,0c0.55,0,1,0.45,1,1v1C18,14.55,17.55,15,17,15z M5.63,14h1.9 l2.43-3.87h0.08L12.47,14h1.9l-3.32-5.2l3.1-4.8h-1.91l-2.19,3.56H9.96L7.75,4h-1.9l3.09,4.8L5.63,14z"/></g>';
var undo = '<path d="M0 0h24v24H0V0z" fill="none"/><path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"/>';
var redo = '<path d="M0 0h24v24H0V0z" fill="none"/><path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"/>';

// Icons source: https://material.io/
const DEFAULT_ICON_HEIGHT = 20;
const DEFAULT_ICON_WIDTH = 20;
const DEFAULT_ICON_FILL = 'currentColor';
const icons = {
  bold,
  italic,
  code,
  underline,
  strike,
  ordered_list: orderedList,
  bullet_list: bulletList,
  blockquote: quote,
  link,
  unlink,
  image,
  align_left: alignLeft,
  align_center: alignCenter,
  align_right: alignRight,
  align_justify: alignJustify,
  text_color: textColor,
  color_fill: colorFill,
  horizontal_rule: horizontalRule,
  format_clear: formatClear,
  indent,
  outdent,
  superscript,
  subscript,
  undo,
  redo,
  path: '<path></path>'
};
class Icon {
  static get(name, fill = DEFAULT_ICON_FILL) {
    const fullPath = icons[name];
    if (fullPath && (fullPath.includes('<path') || fullPath.includes('<g'))) {
      return `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill=${fill}
          height=${DEFAULT_ICON_HEIGHT}
          width=${DEFAULT_ICON_WIDTH}
        >
          ${fullPath}
        </svg>
      `;
    }
    return fullPath;
  }
}
class NgxEditorServiceConfig {
  locals = {};
  icons = {};
  static ɵfac = function NgxEditorServiceConfig_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxEditorServiceConfig)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NgxEditorServiceConfig,
    factory: NgxEditorServiceConfig.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxEditorServiceConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class NgxEditorService {
  config;
  constructor(config) {
    this.config = config;
  }
  get locals() {
    return new Locals(this.config.locals);
  }
  getIcon(icon) {
    return this.config.icons[icon] ? this.config.icons[icon] : Icon.get(icon);
  }
  static ɵfac = function NgxEditorService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxEditorService)(i0.ɵɵinject(NgxEditorServiceConfig, 8));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NgxEditorService,
    factory: NgxEditorService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxEditorService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: NgxEditorServiceConfig,
    decorators: [{
      type: Optional
    }]
  }], null);
})();
const provideMyServiceOptions = config => {
  return {
    locals: config.locals ?? {},
    icons: config.icons ?? {}
  };
};
class ColorPickerComponent {
  el;
  menuService;
  ngxeService;
  presets;
  type;
  constructor(el, menuService, ngxeService) {
    this.el = el;
    this.menuService = menuService;
    this.ngxeService = ngxeService;
  }
  get title() {
    return this.getLabel(this.type === 'text_color' ? 'text_color' : 'background_color');
  }
  get icon() {
    return this.ngxeService.getIcon(this.type === 'text_color' ? 'text_color' : 'color_fill');
  }
  get command() {
    return this.type === 'text_color' ? TextColor : TextBackgroundColor;
  }
  updateSubscription;
  editorView;
  showPopup = false;
  isActive = false;
  activeColors = [];
  canExecute = true;
  getContrastYIQ(hexcolor) {
    const color = hexcolor.replace('#', '');
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? 'black' : 'white';
  }
  onDocumentClick(e) {
    if (!this.el.nativeElement.contains(e.target) && this.showPopup) {
      this.hidePopup();
    }
  }
  hidePopup() {
    this.showPopup = false;
  }
  togglePopup() {
    this.showPopup = !this.showPopup;
  }
  onTogglePopupMouseClick(e) {
    e.preventDefault();
    if (e.button !== 0) {
      return;
    }
    this.togglePopup();
  }
  onTogglePopupKeydown() {
    this.togglePopup();
  }
  remove() {
    const {
      state,
      dispatch
    } = this.editorView;
    this.command.remove()(state, dispatch);
    this.hidePopup();
  }
  onRemoveMouseClick(e) {
    e.preventDefault();
    if (e.button !== 0) {
      return;
    }
    e.preventDefault();
    this.remove();
  }
  onRemoveKeydown() {
    this.remove();
  }
  trackByIndex(index) {
    return index;
  }
  selectColor(color) {
    const {
      state,
      dispatch
    } = this.editorView;
    if (this.type === 'text_color') {
      const attrs = {
        color
      };
      this.command.apply(attrs)(state, dispatch);
    } else {
      const attrs = {
        backgroundColor: color
      };
      this.command.apply(attrs)(state, dispatch);
    }
    if (!this.editorView.hasFocus()) {
      this.editorView.focus();
    }
    this.hidePopup();
  }
  onColorSelectMouseClick(e, color) {
    e.preventDefault();
    if (e.button !== 0) {
      return;
    }
    this.selectColor(color);
  }
  onColorSelectKeydown(color) {
    this.selectColor(color);
  }
  update = view => {
    const {
      state
    } = view;
    this.canExecute = this.command.canExecute(state);
    this.isActive = this.command.isActive(state);
    this.activeColors = [];
    if (this.isActive) {
      this.activeColors = this.command.getActiveColors(state);
    }
  };
  getLabel(key) {
    return this.ngxeService.locals.get(key);
  }
  ngOnInit() {
    this.editorView = this.menuService.editor.view;
    this.updateSubscription = this.menuService.editor.update.subscribe(view => {
      this.update(view);
    });
  }
  ngOnDestroy() {
    this.updateSubscription.unsubscribe();
  }
  static ɵfac = function ColorPickerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ColorPickerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(MenuService), i0.ɵɵdirectiveInject(NgxEditorService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ColorPickerComponent,
    selectors: [["ngx-color-picker"]],
    hostBindings: function ColorPickerComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mousedown", function ColorPickerComponent_mousedown_HostBindingHandler($event) {
          return ctx.onDocumentClick($event);
        }, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      presets: "presets",
      type: "type"
    },
    decls: 5,
    vars: 15,
    consts: [["type", "button", 1, "NgxEditor__MenuItem--Icon", 3, "mousedown", "keydown.enter", "keydown.space", "disabled", "innerHTML", "title", "ariaLabel"], ["class", "NgxEditor__Popup", 4, "ngIf"], [1, "NgxEditor__Popup"], ["class", "NgxEditor__ColorContainer", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "NgxEditor__MenuItem--Button", 3, "mousedown", "keydown.enter", "keydown.space", "disabled"], [1, "NgxEditor__ColorContainer"], ["class", "NgxEditor__Color", 3, "ngStyle", "title", "ngClass", "mousedown", "keydown.enter", "keydown.space", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "NgxEditor__Color", 3, "mousedown", "keydown.enter", "keydown.space", "ngStyle", "title", "ngClass"]],
    template: function ColorPickerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵpipe(1, "sanitizeHtml");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "async");
        i0.ɵɵlistener("mousedown", function ColorPickerComponent_Template_button_mousedown_0_listener($event) {
          return ctx.onTogglePopupMouseClick($event);
        })("keydown.enter", function ColorPickerComponent_Template_button_keydown_enter_0_listener() {
          return ctx.onTogglePopupKeydown();
        })("keydown.space", function ColorPickerComponent_Template_button_keydown_space_0_listener() {
          return ctx.onTogglePopupKeydown();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, ColorPickerComponent_div_4_Template, 5, 6, "div", 1);
      }
      if (rf & 2) {
        i0.ɵɵclassProp("NgxEditor__MenuItem--Active", ctx.isActive || ctx.showPopup)("NgxEditor--Disabled", !ctx.canExecute);
        i0.ɵɵproperty("disabled", !ctx.canExecute)("innerHTML", i0.ɵɵpipeBind1(1, 9, ctx.icon), i0.ɵɵsanitizeHtml)("title", i0.ɵɵpipeBind1(2, 11, ctx.title))("ariaLabel", i0.ɵɵpipeBind1(3, 13, ctx.title));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showPopup);
      }
    },
    dependencies: [AsyncPipe, CommonModule, i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgStyle, SanitizeHtmlPipe],
    styles: ["@charset \"UTF-8\";.NgxEditor__Popup[_ngcontent-%COMP%]{width:230px}.NgxEditor__ColorContainer[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.NgxEditor__ColorContainer[_ngcontent-%COMP%] + .NgxEditor__ColorContainer[_ngcontent-%COMP%]{margin-top:5px}.NgxEditor__Color[_ngcontent-%COMP%]{border:none;outline:none;border-radius:6px;width:24px;height:24px;flex-shrink:0}.NgxEditor__Color[_ngcontent-%COMP%]:focus-visible{outline:1px solid var(--ngx-editor-focus-ring-color);outline-offset:1px}.NgxEditor__Color--Active[_ngcontent-%COMP%]:after{content:\"\\2714\";font-size:90%}.NgxEditor__MenuItem--Button[_ngcontent-%COMP%]{margin-top:5px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColorPickerComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-color-picker',
      imports: [AsyncPipe, CommonModule, SanitizeHtmlPipe],
      template: "<button\n  type=\"button\"\n  class=\"NgxEditor__MenuItem--Icon\"\n  [class.NgxEditor__MenuItem--Active]=\"isActive || showPopup\"\n  [class.NgxEditor--Disabled]=\"!canExecute\"\n  [disabled]=\"!canExecute\"\n  [innerHTML]=\"icon | sanitizeHtml\"\n  (mousedown)=\"onTogglePopupMouseClick($event)\"\n  (keydown.enter)=\"onTogglePopupKeydown()\"\n  (keydown.space)=\"onTogglePopupKeydown()\"\n  [title]=\"title | async\"\n  [ariaLabel]=\"title | async\"\n></button>\n\n<div *ngIf=\"showPopup\" class=\"NgxEditor__Popup\">\n  <div *ngFor=\"let colorGroup of presets; trackBy: trackByIndex\" class=\"NgxEditor__ColorContainer\">\n    <button\n      class=\"NgxEditor__Color\"\n      *ngFor=\"let color of colorGroup; trackBy: trackByIndex\"\n      [ngStyle]=\"{ backgroundColor: color, color: getContrastYIQ(color) }\"\n      [title]=\"color\"\n      (mousedown)=\"onColorSelectMouseClick($event, color)\"\n      (keydown.enter)=\"onColorSelectKeydown(color)\"\n      (keydown.space)=\"onColorSelectKeydown(color)\"\n      [ngClass]=\"{ 'NgxEditor__Color--Active': activeColors.includes(color) }\"\n    ></button>\n  </div>\n\n  <button\n    class=\"NgxEditor__MenuItem--Button\"\n    (mousedown)=\"onRemoveMouseClick($event)\"\n    (keydown.enter)=\"onRemoveKeydown()\"\n    (keydown.space)=\"onRemoveKeydown()\"\n    [disabled]=\"!isActive\"\n  >\n    {{ getLabel('remove') | async }}\n  </button>\n</div>\n",
      styles: ["@charset \"UTF-8\";.NgxEditor__Popup{width:230px}.NgxEditor__ColorContainer{display:flex;justify-content:space-between}.NgxEditor__ColorContainer+.NgxEditor__ColorContainer{margin-top:5px}.NgxEditor__Color{border:none;outline:none;border-radius:6px;width:24px;height:24px;flex-shrink:0}.NgxEditor__Color:focus-visible{outline:1px solid var(--ngx-editor-focus-ring-color);outline-offset:1px}.NgxEditor__Color--Active:after{content:\"\\2714\";font-size:90%}.NgxEditor__MenuItem--Button{margin-top:5px}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: MenuService
  }, {
    type: NgxEditorService
  }], {
    presets: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    onDocumentClick: [{
      type: HostListener,
      args: ['document:mousedown', ['$event']]
    }]
  });
})();
class DropdownComponent {
  ngxeService;
  menuService;
  el;
  editorView;
  updateSubscription;
  group;
  items;
  isDropdownOpen = false;
  disabledItems = [];
  activeItem;
  constructor(ngxeService, menuService, el) {
    this.ngxeService = ngxeService;
    this.menuService = menuService;
    this.el = el;
  }
  get isSelected() {
    return Boolean(this.activeItem || this.isDropdownOpen);
  }
  get isDropdownDisabled() {
    return this.disabledItems.length === this.items.length;
  }
  onDocumentClick(target) {
    if (!this.el.nativeElement.contains(target) && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }
  getName(key) {
    return this.ngxeService.locals.get(key);
  }
  getIsDropdownActive(item) {
    return this.activeItem === item;
  }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  onToggleDropdownMouseClick(e) {
    e.preventDefault();
    if (e.button !== 0) {
      return;
    }
    this.toggleDropdown();
  }
  onToggleDropdownKeydown() {
    this.toggleDropdown();
  }
  trackByIndex(index) {
    return index;
  }
  selectItem(item) {
    const command = ToggleCommands[item];
    const {
      state,
      dispatch
    } = this.editorView;
    command.toggle()(state, dispatch);
    this.isDropdownOpen = false;
  }
  onDropdownItemMouseClick(e, item) {
    e.preventDefault();
    // consider only left click
    if (e.button !== 0) {
      return;
    }
    this.selectItem(item);
  }
  onDropdownItemKeydown(event, item) {
    const e = event;
    e.preventDefault();
    this.selectItem(item);
  }
  update = view => {
    const {
      state
    } = view;
    this.disabledItems = [];
    const activeItems = [];
    this.items.forEach(item => {
      const command = ToggleCommands[item];
      const isActive = command.isActive(state);
      if (isActive) {
        activeItems.push(item);
      }
      if (!command.canExecute(state)) {
        this.disabledItems.push(item);
      }
    });
    if (activeItems.length === 1) {
      [this.activeItem] = activeItems;
    } else {
      this.activeItem = null;
    }
  };
  ngOnInit() {
    this.editorView = this.menuService.editor.view;
    this.updateSubscription = this.menuService.editor.update.subscribe(view => {
      this.update(view);
    });
  }
  ngOnDestroy() {
    this.updateSubscription.unsubscribe();
  }
  static ɵfac = function DropdownComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownComponent)(i0.ɵɵdirectiveInject(NgxEditorService), i0.ɵɵdirectiveInject(MenuService), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DropdownComponent,
    selectors: [["ngx-dropdown"]],
    hostBindings: function DropdownComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mousedown", function DropdownComponent_mousedown_HostBindingHandler($event) {
          return ctx.onDocumentClick($event.target);
        }, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      group: "group",
      items: "items"
    },
    decls: 5,
    vars: 13,
    consts: [["type", "button", "aria-haspopup", "listbox", 1, "NgxEditor__Dropdown--Text", 3, "mousedown", "keydown.enter", "keydown.space", "disabled", "ariaLabel", "ariaExpanded"], ["class", "NgxEditor__Dropdown--DropdownMenu", "role", "listbox", 4, "ngIf"], ["role", "listbox", 1, "NgxEditor__Dropdown--DropdownMenu"], ["type", "button", "class", "NgxEditor__Dropdown--Item", "role", "option", 3, "ngClass", "ariaLabel", "mousedown", "keydown.enter", "keydown.space", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["type", "button", "role", "option", 1, "NgxEditor__Dropdown--Item", 3, "mousedown", "keydown.enter", "keydown.space", "ngClass", "ariaLabel"]],
    template: function DropdownComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵlistener("mousedown", function DropdownComponent_Template_button_mousedown_0_listener($event) {
          return ctx.onToggleDropdownMouseClick($event);
        })("keydown.enter", function DropdownComponent_Template_button_keydown_enter_0_listener() {
          return ctx.onToggleDropdownKeydown();
        })("keydown.space", function DropdownComponent_Template_button_keydown_space_0_listener() {
          return ctx.onToggleDropdownKeydown();
        });
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, DropdownComponent_div_4_Template, 2, 2, "div", 1);
      }
      if (rf & 2) {
        i0.ɵɵclassProp("NgxEditor__Dropdown--Selected", ctx.isSelected)("NgxEditor--Disabled", ctx.isDropdownDisabled);
        i0.ɵɵproperty("disabled", ctx.isDropdownDisabled)("ariaLabel", i0.ɵɵpipeBind1(1, 9, ctx.getName(ctx.activeItem || ctx.group)))("ariaExpanded", ctx.isDropdownOpen);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 11, ctx.getName(ctx.activeItem || ctx.group)), "\n");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isDropdownOpen);
      }
    },
    dependencies: [AsyncPipe, CommonModule, i3.NgClass, i3.NgForOf, i3.NgIf],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-dropdown',
      imports: [AsyncPipe, CommonModule],
      template: "<button\n  type=\"button\"\n  class=\"NgxEditor__Dropdown--Text\"\n  [class.NgxEditor__Dropdown--Selected]=\"isSelected\"\n  [disabled]=\"isDropdownDisabled\"\n  [class.NgxEditor--Disabled]=\"isDropdownDisabled\"\n  (mousedown)=\"onToggleDropdownMouseClick($event)\"\n  (keydown.enter)=\"onToggleDropdownKeydown()\"\n  (keydown.space)=\"onToggleDropdownKeydown()\"\n  [ariaLabel]=\"getName(activeItem || group) | async\"\n  aria-haspopup=\"listbox\"\n  [ariaExpanded]=\"isDropdownOpen\"\n>\n  {{ getName(activeItem || group) | async }}\n</button>\n\n<div class=\"NgxEditor__Dropdown--DropdownMenu\" *ngIf=\"isDropdownOpen\" role=\"listbox\">\n  <button\n    type=\"button\"\n    class=\"NgxEditor__Dropdown--Item\"\n    *ngFor=\"let item of items; trackBy: trackByIndex\"\n    (mousedown)=\"onDropdownItemMouseClick($event, item)\"\n    (keydown.enter)=\"onDropdownItemKeydown($event, item)\"\n    (keydown.space)=\"onDropdownItemKeydown($event, item)\"\n    [ngClass]=\"{\n      'NgxEditor__Dropdown--Active': item === activeItem,\n      'NgxEditor--Disabled': disabledItems.includes(item),\n    }\"\n    [ariaLabel]=\"getName(item) | async\"\n    role=\"option\"\n    [attr.aria-selected]=\"item === activeItem\"\n  >\n    {{ getName(item) | async }}\n  </button>\n</div>\n"
    }]
  }], () => [{
    type: NgxEditorService
  }, {
    type: MenuService
  }, {
    type: i0.ElementRef
  }], {
    group: [{
      type: Input
    }],
    items: [{
      type: Input
    }],
    onDocumentClick: [{
      type: HostListener,
      args: ['document:mousedown', ['$event.target']]
    }]
  });
})();
class ImageComponent {
  el;
  ngxeService;
  menuService;
  showPopup = false;
  isActive = false;
  componentId = uniq();
  updateSubscription;
  form = new FormGroup({
    src: new FormControl('', [Validators$1.required, Validators$1.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/??([^#\n\r]*)?#?([^\n\r]*)')]),
    alt: new FormControl(''),
    title: new FormControl('')
  });
  editorView;
  constructor(el, ngxeService, menuService) {
    this.el = el;
    this.ngxeService = ngxeService;
    this.menuService = menuService;
  }
  get icon() {
    return this.ngxeService.getIcon('image');
  }
  get src() {
    return this.form.get('src');
  }
  onDocumentClick(e) {
    if (!this.el.nativeElement.contains(e.target) && this.showPopup) {
      this.hideForm();
    }
  }
  getId(name) {
    return `${name}-${this.componentId}`;
  }
  getLabel(key) {
    return this.ngxeService.locals.get(key);
  }
  hideForm() {
    this.showPopup = false;
    this.form.reset({
      src: '',
      alt: '',
      title: ''
    });
  }
  togglePopup() {
    this.showPopup = !this.showPopup;
    if (this.showPopup) {
      this.fillForm();
    }
  }
  onTogglePopupMouseClick(e) {
    if (e.button !== 0) {
      return;
    }
    this.togglePopup();
  }
  onTogglePopupKeydown() {
    this.togglePopup();
  }
  fillForm() {
    const {
      state
    } = this.editorView;
    const {
      selection
    } = state;
    if (selection instanceof NodeSelection && this.isActive) {
      const {
        src,
        alt = '',
        title = ''
      } = selection.node.attrs;
      this.form.setValue({
        src,
        alt,
        title
      });
    }
  }
  update = view => {
    const {
      state
    } = view;
    this.isActive = Image.isActive(state);
  };
  insertLink(e) {
    e.preventDefault();
    const {
      src,
      alt,
      title
    } = this.form.getRawValue();
    const {
      dispatch,
      state
    } = this.editorView;
    const attrs = {
      alt,
      title
    };
    Image.insert(src, attrs)(state, dispatch);
    this.editorView.focus();
    this.hideForm();
  }
  ngOnInit() {
    this.editorView = this.menuService.editor.view;
    this.updateSubscription = this.menuService.editor.update.subscribe(view => {
      this.update(view);
    });
  }
  ngOnDestroy() {
    this.updateSubscription.unsubscribe();
  }
  static ɵfac = function ImageComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ImageComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(NgxEditorService), i0.ɵɵdirectiveInject(MenuService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ImageComponent,
    selectors: [["ngx-image"]],
    hostBindings: function ImageComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mousedown", function ImageComponent_mousedown_HostBindingHandler($event) {
          return ctx.onDocumentClick($event);
        }, i0.ɵɵresolveDocument);
      }
    },
    decls: 5,
    vars: 13,
    consts: [["type", "button", "aria-haspopup", "dialog", 1, "NgxEditor__MenuItem--Icon", 3, "mousedown", "keydown.enter", "keydown.space", "innerHTML", "title", "ariaLabel", "ariaExpanded"], ["class", "NgxEditor__Popup", 4, "ngIf"], [1, "NgxEditor__Popup"], [1, "NgxEditor__Popup--Form", 3, "ngSubmit", "formGroup"], [1, "NgxEditor__Popup--FormGroup"], [1, "NgxEditor__Popup--Col"], [1, "NgxEditor__Popup--Label", 3, "htmlFor"], ["type", "url", "formControlName", "src", "autocomplete", "off", 3, "id"], ["class", "NgxEditor__HelpText NgxEditor__HelpText--Error", 4, "ngIf"], ["type", "text", "formControlName", "alt", "autocomplete", "off", 3, "id"], ["type", "text", "formControlName", "title", "autocomplete", "off", 3, "id"], ["type", "submit", 3, "disabled"], [1, "NgxEditor__HelpText", "NgxEditor__HelpText--Error"]],
    template: function ImageComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵpipe(1, "sanitizeHtml");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "async");
        i0.ɵɵlistener("mousedown", function ImageComponent_Template_button_mousedown_0_listener($event) {
          return ctx.onTogglePopupMouseClick($event);
        })("keydown.enter", function ImageComponent_Template_button_keydown_enter_0_listener() {
          return ctx.onTogglePopupKeydown();
        })("keydown.space", function ImageComponent_Template_button_keydown_space_0_listener() {
          return ctx.onTogglePopupKeydown();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, ImageComponent_div_4_Template, 24, 21, "div", 1);
      }
      if (rf & 2) {
        i0.ɵɵclassProp("NgxEditor__MenuItem--Active", ctx.isActive || ctx.showPopup);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 7, ctx.icon), i0.ɵɵsanitizeHtml)("title", i0.ɵɵpipeBind1(2, 9, ctx.getLabel("insertImage")))("ariaLabel", i0.ɵɵpipeBind1(3, 11, ctx.getLabel("insertImage")))("ariaExpanded", ctx.showPopup);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showPopup);
      }
    },
    dependencies: [AsyncPipe, SanitizeHtmlPipe, ReactiveFormsModule, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, CommonModule, i3.NgIf],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-image',
      imports: [AsyncPipe, SanitizeHtmlPipe, ReactiveFormsModule, CommonModule],
      template: "<button\n  type=\"button\"\n  class=\"NgxEditor__MenuItem--Icon\"\n  [class.NgxEditor__MenuItem--Active]=\"isActive || showPopup\"\n  [innerHTML]=\"icon | sanitizeHtml\"\n  (mousedown)=\"onTogglePopupMouseClick($event)\"\n  (keydown.enter)=\"onTogglePopupKeydown()\"\n  (keydown.space)=\"onTogglePopupKeydown()\"\n  [title]=\"getLabel('insertImage') | async\"\n  [ariaLabel]=\"getLabel('insertImage') | async\"\n  aria-haspopup=\"dialog\"\n  [ariaExpanded]=\"showPopup\"\n></button>\n\n<!-- popup -->\n<div *ngIf=\"showPopup\" class=\"NgxEditor__Popup\">\n  <form class=\"NgxEditor__Popup--Form\" [formGroup]=\"form\" (ngSubmit)=\"insertLink($event)\">\n    <div class=\"NgxEditor__Popup--FormGroup\">\n      <div class=\"NgxEditor__Popup--Col\">\n        <label class=\"NgxEditor__Popup--Label\" [htmlFor]=\"getId('image-popup-url')\">{{\n          getLabel('url') | async\n        }}</label>\n        <input type=\"url\" [id]=\"getId('image-popup-url')\" formControlName=\"src\" autocomplete=\"off\" />\n        <div *ngIf=\"src.touched && src.invalid\" class=\"NgxEditor__HelpText NgxEditor__HelpText--Error\">\n          {{ src.errors?.['pattern'] && getLabel('enterValidUrl') | async }}\n        </div>\n      </div>\n    </div>\n\n    <div class=\"NgxEditor__Popup--FormGroup\">\n      <div class=\"NgxEditor__Popup--Col\">\n        <label class=\"NgxEditor__Popup--Label\" [htmlFor]=\"getId('image-popup-label')\">{{\n          getLabel('altText') | async\n        }}</label>\n        <input type=\"text\" [id]=\"getId('image-popup-label')\" formControlName=\"alt\" autocomplete=\"off\" />\n      </div>\n    </div>\n\n    <div class=\"NgxEditor__Popup--FormGroup\">\n      <div class=\"NgxEditor__Popup--Col\">\n        <label class=\"NgxEditor__Popup--Label\" [htmlFor]=\"getId('image-popup-title')\">{{\n          getLabel('title') | async\n        }}</label>\n        <input type=\"text\" [id]=\"getId('image-popup-title')\" formControlName=\"title\" autocomplete=\"off\" />\n      </div>\n    </div>\n\n    <button type=\"submit\" [disabled]=\"!form.valid || !form.dirty\">{{ getLabel('insert') | async }}</button>\n  </form>\n</div>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: NgxEditorService
  }, {
    type: MenuService
  }], {
    onDocumentClick: [{
      type: HostListener,
      args: ['document:mousedown', ['$event']]
    }]
  });
})();
class InsertCommandComponent {
  ngxeService;
  menuService;
  toolbarItem;
  get name() {
    return this.toolbarItem;
  }
  html;
  editorView;
  disabled = false;
  updateSubscription;
  constructor(ngxeService, menuService) {
    this.ngxeService = ngxeService;
    this.menuService = menuService;
  }
  onMouseClick(e) {
    e.preventDefault();
    if (e.button !== 0) {
      return;
    }
    this.insert();
  }
  onKeydown() {
    this.insert();
  }
  insert() {
    const {
      state,
      dispatch
    } = this.editorView;
    const command = InsertCommands[this.name];
    command.insert()(state, dispatch);
  }
  update = view => {
    const {
      state
    } = view;
    const command = InsertCommands[this.name];
    this.disabled = !command.canExecute(state);
  };
  getTitle(name) {
    return this.ngxeService.locals.get(name);
  }
  ngOnInit() {
    this.html = this.ngxeService.getIcon(this.name);
    this.editorView = this.menuService.editor.view;
    this.updateSubscription = this.menuService.editor.update.subscribe(view => {
      this.update(view);
    });
  }
  ngOnDestroy() {
    this.updateSubscription.unsubscribe();
  }
  static ɵfac = function InsertCommandComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InsertCommandComponent)(i0.ɵɵdirectiveInject(NgxEditorService), i0.ɵɵdirectiveInject(MenuService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: InsertCommandComponent,
    selectors: [["ngx-insert-command"]],
    inputs: {
      toolbarItem: "toolbarItem"
    },
    decls: 4,
    vars: 12,
    consts: [["type", "button", 1, "NgxEditor__MenuItem--Icon", 3, "mousedown", "keydown.enter", "keydown.space", "disabled", "innerHTML", "title", "ariaLabel"]],
    template: function InsertCommandComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵdomElementStart(0, "button", 0);
        i0.ɵɵpipe(1, "sanitizeHtml");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "async");
        i0.ɵɵdomListener("mousedown", function InsertCommandComponent_Template_button_mousedown_0_listener($event) {
          return ctx.onMouseClick($event);
        })("keydown.enter", function InsertCommandComponent_Template_button_keydown_enter_0_listener() {
          return ctx.onKeydown();
        })("keydown.space", function InsertCommandComponent_Template_button_keydown_space_0_listener() {
          return ctx.onKeydown();
        });
        i0.ɵɵdomElementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("NgxEditor--Disabled", ctx.disabled);
        i0.ɵɵdomProperty("disabled", ctx.disabled)("innerHTML", i0.ɵɵpipeBind1(1, 6, ctx.html), i0.ɵɵsanitizeHtml)("title", i0.ɵɵpipeBind1(2, 8, ctx.getTitle(ctx.name)))("ariaLabel", i0.ɵɵpipeBind1(3, 10, ctx.getTitle(ctx.name)));
      }
    },
    dependencies: [AsyncPipe, SanitizeHtmlPipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InsertCommandComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-insert-command',
      imports: [AsyncPipe, SanitizeHtmlPipe],
      template: "<button\n  type=\"button\"\n  class=\"NgxEditor__MenuItem--Icon\"\n  [disabled]=\"disabled\"\n  [class.NgxEditor--Disabled]=\"disabled\"\n  [innerHTML]=\"html | sanitizeHtml\"\n  (mousedown)=\"onMouseClick($event)\"\n  (keydown.enter)=\"onKeydown()\"\n  (keydown.space)=\"onKeydown()\"\n  [title]=\"getTitle(name) | async\"\n  [ariaLabel]=\"getTitle(name) | async\"\n></button>\n"
    }]
  }], () => [{
    type: NgxEditorService
  }, {
    type: MenuService
  }], {
    toolbarItem: [{
      type: Input
    }]
  });
})();
const DEFAULT_LINK_OPTIONS = {
  showOpenInNewTab: true
};
class LinkComponent {
  el;
  ngxeService;
  menuService;
  options = DEFAULT_LINK_OPTIONS;
  showPopup = false;
  isActive = false;
  canExecute = true;
  componentId = uniq();
  form;
  editorView;
  updateSubscription;
  constructor(el, ngxeService, menuService) {
    this.el = el;
    this.ngxeService = ngxeService;
    this.menuService = menuService;
  }
  get icon() {
    return this.ngxeService.getIcon(this.isActive ? 'unlink' : 'link');
  }
  get title() {
    return this.ngxeService.locals.get(this.isActive ? 'removeLink' : 'insertLink');
  }
  get href() {
    return this.form.get('href');
  }
  get text() {
    return this.form.get('text');
  }
  onDocumentClick(e) {
    if (!this.el.nativeElement.contains(e.target) && this.showPopup) {
      this.hidePopup();
    }
  }
  getId(name) {
    return `${name}-${this.componentId}`;
  }
  getLabel(key) {
    return this.ngxeService.locals.get(key);
  }
  hidePopup() {
    this.showPopup = false;
    this.form.reset({
      href: '',
      text: '',
      openInNewTab: true
    });
    this.text.enable();
  }
  togglePopup() {
    const {
      state,
      dispatch
    } = this.editorView;
    if (this.isActive) {
      Link.remove(state, dispatch);
      return;
    }
    this.showPopup = !this.showPopup;
    if (this.showPopup) {
      this.setText();
    }
  }
  onTogglePopupMouseClick(e) {
    if (e.button !== 0) {
      return;
    }
    this.togglePopup();
  }
  onTogglePopupKeydown() {
    this.togglePopup();
  }
  setText = () => {
    const {
      state: {
        selection,
        doc
      }
    } = this.editorView;
    const {
      empty,
      from,
      to
    } = selection;
    const selectedText = !empty ? doc.textBetween(from, to) : '';
    if (selectedText) {
      this.text.patchValue(selectedText);
      this.text.disable();
    }
  };
  update = view => {
    const {
      state
    } = view;
    this.isActive = Link.isActive(state, {
      strict: false
    });
    this.canExecute = Link.canExecute(state);
  };
  insertLink(e) {
    e.preventDefault();
    const {
      text,
      href,
      openInNewTab
    } = this.form.getRawValue();
    const {
      dispatch,
      state
    } = this.editorView;
    const {
      selection
    } = state;
    let target;
    if (this.options.showOpenInNewTab) {
      target = openInNewTab ? '_blank' : '_self';
    }
    const attrs = {
      title: href,
      href,
      target
    };
    if (selection.empty) {
      Link.insert(text, attrs)(state, dispatch);
      this.editorView.focus();
    } else {
      Link.update(attrs)(state, dispatch);
    }
    this.hidePopup();
  }
  ngOnInit() {
    this.editorView = this.menuService.editor.view;
    this.form = new FormGroup({
      href: new FormControl('', [Validators$1.required, Validators$1.pattern(this.menuService.editor.linkValidationPattern)]),
      text: new FormControl('', [Validators$1.required]),
      openInNewTab: new FormControl(true)
    });
    this.updateSubscription = this.menuService.editor.update.subscribe(view => {
      this.update(view);
    });
  }
  ngOnDestroy() {
    this.updateSubscription.unsubscribe();
  }
  static ɵfac = function LinkComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LinkComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(NgxEditorService), i0.ɵɵdirectiveInject(MenuService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LinkComponent,
    selectors: [["ngx-link"]],
    hostBindings: function LinkComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mousedown", function LinkComponent_mousedown_HostBindingHandler($event) {
          return ctx.onDocumentClick($event);
        }, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      options: [2, "options", "options", value => ({
        ...DEFAULT_LINK_OPTIONS,
        ...value
      })]
    },
    decls: 5,
    vars: 16,
    consts: [["type", "button", "aria-haspopup", "dialog", 1, "NgxEditor__MenuItem--Icon", 3, "mousedown", "keydown.enter", "keydown.space", "disabled", "innerHTML", "title", "ariaLabel", "ariaExpanded"], ["class", "NgxEditor__Popup", 4, "ngIf"], [1, "NgxEditor__Popup"], [1, "NgxEditor__Popup--Form", 3, "ngSubmit", "formGroup"], [1, "NgxEditor__Popup--FormGroup"], [1, "NgxEditor__Popup--Col"], [1, "NgxEditor__Popup--Label", 3, "htmlFor"], ["type", "url", "formControlName", "href", "autocomplete", "off", 3, "id"], ["class", "NgxEditor__HelpText NgxEditor__HelpText--Error", 4, "ngIf"], ["type", "text", "formControlName", "text", "autocomplete", "off", 3, "id"], ["class", "NgxEditor__Popup--FormGroup", 4, "ngIf"], ["type", "submit", 3, "disabled"], [1, "NgxEditor__HelpText", "NgxEditor__HelpText--Error"], ["type", "checkbox", "formControlName", "openInNewTab"]],
    template: function LinkComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵpipe(1, "sanitizeHtml");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "async");
        i0.ɵɵlistener("mousedown", function LinkComponent_Template_button_mousedown_0_listener($event) {
          return ctx.onTogglePopupMouseClick($event);
        })("keydown.enter", function LinkComponent_Template_button_keydown_enter_0_listener() {
          return ctx.onTogglePopupKeydown();
        })("keydown.space", function LinkComponent_Template_button_keydown_space_0_listener() {
          return ctx.onTogglePopupKeydown();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, LinkComponent_div_4_Template, 20, 18, "div", 1);
      }
      if (rf & 2) {
        i0.ɵɵclassProp("NgxEditor__MenuItem--Active", ctx.isActive || ctx.showPopup)("NgxEditor--Disabled", !ctx.canExecute);
        i0.ɵɵproperty("disabled", !ctx.canExecute)("innerHTML", i0.ɵɵpipeBind1(1, 10, ctx.icon), i0.ɵɵsanitizeHtml)("title", i0.ɵɵpipeBind1(2, 12, ctx.title))("ariaLabel", i0.ɵɵpipeBind1(3, 14, ctx.title))("ariaExpanded", ctx.showPopup);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showPopup);
      }
    },
    dependencies: [AsyncPipe, CommonModule, i3.NgIf, ReactiveFormsModule, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, SanitizeHtmlPipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LinkComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-link',
      imports: [AsyncPipe, CommonModule, ReactiveFormsModule, SanitizeHtmlPipe],
      template: "<button\n  type=\"button\"\n  class=\"NgxEditor__MenuItem--Icon\"\n  [class.NgxEditor__MenuItem--Active]=\"isActive || showPopup\"\n  [class.NgxEditor--Disabled]=\"!canExecute\"\n  [disabled]=\"!canExecute\"\n  [innerHTML]=\"icon | sanitizeHtml\"\n  (mousedown)=\"onTogglePopupMouseClick($event)\"\n  (keydown.enter)=\"onTogglePopupKeydown()\"\n  (keydown.space)=\"onTogglePopupKeydown()\"\n  [title]=\"title | async\"\n  [ariaLabel]=\"title | async\"\n  aria-haspopup=\"dialog\"\n  [ariaExpanded]=\"showPopup\"\n></button>\n\n<!-- popup -->\n<div *ngIf=\"showPopup\" class=\"NgxEditor__Popup\">\n  <form class=\"NgxEditor__Popup--Form\" [formGroup]=\"form\" (ngSubmit)=\"insertLink($event)\">\n    <div class=\"NgxEditor__Popup--FormGroup\">\n      <div class=\"NgxEditor__Popup--Col\">\n        <label class=\"NgxEditor__Popup--Label\" [htmlFor]=\"getId('link-popup-url')\">{{ getLabel('url') | async }}</label>\n        <input type=\"url\" [id]=\"getId('link-popup-url')\" formControlName=\"href\" autocomplete=\"off\" />\n        <div *ngIf=\"href.touched && href.invalid\" class=\"NgxEditor__HelpText NgxEditor__HelpText--Error\">\n          {{ href.errors?.['pattern'] && getLabel('enterValidUrl') | async }}\n        </div>\n      </div>\n    </div>\n\n    <div class=\"NgxEditor__Popup--FormGroup\">\n      <div class=\"NgxEditor__Popup--Col\">\n        <label class=\"NgxEditor__Popup--Label\" [htmlFor]=\"getId('link-popup-label')\">{{\n          getLabel('text') | async\n        }}</label>\n        <input type=\"text\" [id]=\"getId('link-popup-label')\" formControlName=\"text\" autocomplete=\"off\" />\n        <div *ngIf=\"text.touched && text.invalid\" class=\"NgxEditor__HelpText NgxEditor__HelpText--Error\">\n          {{ text.errors?.['required'] && 'This is required' }}\n        </div>\n      </div>\n    </div>\n\n    <div class=\"NgxEditor__Popup--FormGroup\" *ngIf=\"this.options.showOpenInNewTab\">\n      <div class=\"NgxEditor__Popup--Col\">\n        <label>\n          <input type=\"checkbox\" formControlName=\"openInNewTab\" />\n          {{ getLabel('openInNewTab') | async }}\n        </label>\n      </div>\n    </div>\n\n    <button type=\"submit\" [disabled]=\"!form.valid\">{{ getLabel('insert') | async }}</button>\n  </form>\n</div>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: NgxEditorService
  }, {
    type: MenuService
  }], {
    options: [{
      type: Input,
      args: [{
        transform: value => ({
          ...DEFAULT_LINK_OPTIONS,
          ...value
        })
      }]
    }],
    onDocumentClick: [{
      type: HostListener,
      args: ['document:mousedown', ['$event']]
    }]
  });
})();
class ToggleCommandComponent {
  ngxeService;
  menuService;
  toolbarItem;
  get name() {
    return this.toolbarItem;
  }
  html;
  editorView;
  isActive = false;
  disabled = false;
  updateSubscription;
  constructor(ngxeService, menuService) {
    this.ngxeService = ngxeService;
    this.menuService = menuService;
  }
  toggle() {
    const {
      state,
      dispatch
    } = this.editorView;
    const command = ToggleCommands[this.name];
    command.toggle()(state, dispatch);
  }
  onMouseClick(e) {
    e.preventDefault();
    if (e.button !== 0) {
      return;
    }
    this.toggle();
  }
  onKeydown() {
    this.toggle();
  }
  update = view => {
    const {
      state
    } = view;
    const command = ToggleCommands[this.name];
    this.isActive = command.isActive(state);
    this.disabled = !command.canExecute(state);
  };
  getTitle(name) {
    return this.ngxeService.locals.get(name);
  }
  ngOnInit() {
    this.html = this.ngxeService.getIcon(this.name);
    this.editorView = this.menuService.editor.view;
    this.updateSubscription = this.menuService.editor.update.subscribe(view => {
      this.update(view);
    });
  }
  ngOnDestroy() {
    this.updateSubscription.unsubscribe();
  }
  static ɵfac = function ToggleCommandComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToggleCommandComponent)(i0.ɵɵdirectiveInject(NgxEditorService), i0.ɵɵdirectiveInject(MenuService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ToggleCommandComponent,
    selectors: [["ngx-toggle-command"]],
    inputs: {
      toolbarItem: "toolbarItem"
    },
    decls: 4,
    vars: 14,
    consts: [["type", "button", 1, "NgxEditor__MenuItem--Icon", 3, "mousedown", "keydown.enter", "keydown.space", "disabled", "innerHTML", "title", "ariaLabel"]],
    template: function ToggleCommandComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵdomElementStart(0, "button", 0);
        i0.ɵɵpipe(1, "sanitizeHtml");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "async");
        i0.ɵɵdomListener("mousedown", function ToggleCommandComponent_Template_button_mousedown_0_listener($event) {
          return ctx.onMouseClick($event);
        })("keydown.enter", function ToggleCommandComponent_Template_button_keydown_enter_0_listener() {
          return ctx.onKeydown();
        })("keydown.space", function ToggleCommandComponent_Template_button_keydown_space_0_listener() {
          return ctx.onKeydown();
        });
        i0.ɵɵdomElementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("NgxEditor__MenuItem--Active", ctx.isActive)("NgxEditor--Disabled", ctx.disabled);
        i0.ɵɵdomProperty("disabled", ctx.disabled)("innerHTML", i0.ɵɵpipeBind1(1, 8, ctx.html), i0.ɵɵsanitizeHtml)("title", i0.ɵɵpipeBind1(2, 10, ctx.getTitle(ctx.name)))("ariaLabel", i0.ɵɵpipeBind1(3, 12, ctx.getTitle(ctx.name)));
      }
    },
    dependencies: [AsyncPipe, SanitizeHtmlPipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleCommandComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-toggle-command',
      imports: [AsyncPipe, SanitizeHtmlPipe],
      template: "<button\n  type=\"button\"\n  class=\"NgxEditor__MenuItem--Icon\"\n  [class.NgxEditor__MenuItem--Active]=\"isActive\"\n  [class.NgxEditor--Disabled]=\"disabled\"\n  [disabled]=\"disabled\"\n  [innerHTML]=\"html | sanitizeHtml\"\n  (mousedown)=\"onMouseClick($event)\"\n  (keydown.enter)=\"onKeydown()\"\n  (keydown.space)=\"onKeydown()\"\n  [title]=\"getTitle(name) | async\"\n  [ariaLabel]=\"getTitle(name) | async\"\n></button>\n"
    }]
  }], () => [{
    type: NgxEditorService
  }, {
    type: MenuService
  }], {
    toolbarItem: [{
      type: Input
    }]
  });
})();
const DEFAULT_TOOLBAR = [['bold', 'italic'], ['code', 'blockquote'], ['underline', 'strike'], ['ordered_list', 'bullet_list'], [{
  heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
}], ['link', 'image'], ['text_color', 'background_color'], ['align_left', 'align_center', 'align_right', 'align_justify'], ['format_clear']];
const TOOLBAR_MINIMAL = [['bold', 'italic'], [{
  heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
}], ['link', 'image'], ['text_color', 'background_color']];
const TOOLBAR_FULL = [['bold', 'italic'], ['code', 'blockquote'], ['underline', 'strike'], ['ordered_list', 'bullet_list'], [{
  heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
}], ['link', 'image'], ['text_color', 'background_color'], ['align_left', 'align_center', 'align_right', 'align_justify'], ['horizontal_rule', 'format_clear', 'indent', 'outdent'], ['superscript', 'subscript'], ['undo', 'redo']];
const DEFAULT_COLOR_PRESETS = ['#b60205', '#d93f0b', '#fbca04', '#0e8a16', '#006b75', '#1d76db', '#0052cc', '#5319e7', '#e99695', '#f9d0c4', '#fef2c0', '#c2e0c6', '#bfdadc', '#c5def5', '#bfd4f2', '#d4c5f9'];
class NgxEditorMenuComponent {
  menuService;
  toolbar = TOOLBAR_MINIMAL;
  colorPresets = DEFAULT_COLOR_PRESETS;
  disabled = false;
  editor;
  customMenuRef = null;
  dropdownPlacement = 'bottom';
  toggleCommands = ['bold', 'italic', 'underline', 'strike', 'code', 'blockquote', 'ordered_list', 'bullet_list', 'align_left', 'align_center', 'align_right', 'align_justify', 'superscript', 'subscript'];
  insertCommands = ['horizontal_rule', 'format_clear', 'indent', 'outdent', 'undo', 'redo'];
  iconContainerClass = ['NgxEditor__MenuItem', 'NgxEditor__MenuItem--IconContainer'];
  dropdownContainerClass = ['NgxEditor__Dropdown'];
  seperatorClass = ['NgxEditor__Seperator'];
  constructor(menuService) {
    this.menuService = menuService;
  }
  get presets() {
    const col = 8;
    const colors = [];
    this.colorPresets.forEach((color, index) => {
      const row = Math.floor(index / col);
      if (!colors[row]) {
        colors.push([]);
      }
      colors[row].push(color);
    });
    return colors;
  }
  trackByIndex(index) {
    return index;
  }
  isDropDown(item) {
    if (item?.heading) {
      return true;
    }
    return false;
  }
  getDropdownItems(item) {
    return item;
  }
  isLinkItem(item) {
    if (item === 'link') {
      return true;
    }
    // NOTE: it is not sufficient to check for a `link` property
    // as String.prototype.link is a valid (although deprecated) method
    return typeof item === 'object' && typeof item?.link === 'object';
  }
  isLinkWithOptions(item) {
    // NOTE: it is not sufficient to check for a `link` property
    // as String.prototype.link is a valid (although deprecated) method
    return typeof item === 'object' && typeof item?.link === 'object';
  }
  getLinkOptions(item) {
    return item?.link;
  }
  ngOnInit() {
    if (!this.editor) {
      throw new NgxEditorError('Required editor instance to initialize menu component');
    }
    this.menuService.editor = this.editor;
  }
  static ɵfac = function NgxEditorMenuComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxEditorMenuComponent)(i0.ɵɵdirectiveInject(MenuService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NgxEditorMenuComponent,
    selectors: [["ngx-editor-menu"]],
    inputs: {
      toolbar: "toolbar",
      colorPresets: "colorPresets",
      disabled: "disabled",
      editor: "editor",
      customMenuRef: "customMenuRef",
      dropdownPlacement: "dropdownPlacement"
    },
    features: [i0.ɵɵProvidersFeature([MenuService])],
    decls: 3,
    vars: 7,
    consts: [[1, "NgxEditor__MenuBar", 3, "ngClass"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [4, "ngIf"], [3, "toolbarItem", "class", 4, "ngIf"], [3, "class", 4, "ngIf"], ["type", "text_color", 3, "class", "presets", 4, "ngIf"], ["type", "background_color", 3, "class", "presets", 4, "ngIf"], [3, "toolbarItem"], [3, "options"], [3, "class", "group", "items", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "group", "items"], ["type", "text_color", 3, "presets"], ["type", "background_color", 3, "presets"], [3, "ngTemplateOutlet"]],
    template: function NgxEditorMenuComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, NgxEditorMenuComponent_ng_container_1_Template, 2, 2, "ng-container", 1)(2, NgxEditorMenuComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c7, ctx.disabled, ctx.dropdownPlacement === "top"));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.toolbar)("ngForTrackBy", ctx.trackByIndex);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.customMenuRef);
      }
    },
    dependencies: [CommonModule, i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i3.KeyValuePipe, ColorPickerComponent, DropdownComponent, ToggleCommandComponent, InsertCommandComponent, LinkComponent, ImageComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxEditorMenuComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-editor-menu',
      providers: [MenuService],
      imports: [CommonModule, ColorPickerComponent, DropdownComponent, ToggleCommandComponent, InsertCommandComponent, LinkComponent, ImageComponent],
      template: "<div\n  class=\"NgxEditor__MenuBar\"\n  [ngClass]=\"{ 'NgxEditor--Disabled': disabled, 'NgxEditor__MenuBar--Reverse': dropdownPlacement === 'top' }\"\n>\n  <ng-container *ngFor=\"let toolbarItem of toolbar; let lastToolbarItem = last; trackBy: trackByIndex\">\n    <ng-container *ngFor=\"let item of toolbarItem; let lastItem = last; trackBy: trackByIndex\">\n      <!-- toggle icons -->\n      <ngx-toggle-command [toolbarItem]=\"item\" [class]=\"iconContainerClass\" *ngIf=\"toggleCommands.includes(item)\">\n      </ngx-toggle-command>\n\n      <ngx-insert-command [toolbarItem]=\"item\" [class]=\"iconContainerClass\" *ngIf=\"insertCommands.includes(item)\">\n      </ngx-insert-command>\n\n      <!-- link -->\n      <ng-container *ngIf=\"isLinkItem(item)\">\n        <ngx-link [class]=\"iconContainerClass\" [options]=\"getLinkOptions(item)\"></ngx-link>\n      </ng-container>\n\n      <!-- image -->\n      <ngx-image [class]=\"iconContainerClass\" *ngIf=\"item === 'image'\"> </ngx-image>\n\n      <!-- dropdown -->\n      <ng-container *ngIf=\"isDropDown(item)\">\n        <ngx-dropdown\n          *ngFor=\"let dropdownItem of getDropdownItems(item) | keyvalue; trackBy: trackByIndex\"\n          [class]=\"dropdownContainerClass\"\n          [group]=\"dropdownItem.key\"\n          [items]=\"dropdownItem.value\"\n        >\n        </ngx-dropdown>\n      </ng-container>\n\n      <!-- text color picker -->\n      <ngx-color-picker\n        [class]=\"iconContainerClass\"\n        *ngIf=\"item === 'text_color'\"\n        type=\"text_color\"\n        [presets]=\"presets\"\n      >\n      </ngx-color-picker>\n      <!-- background color picker -->\n      <ngx-color-picker\n        [class]=\"iconContainerClass\"\n        *ngIf=\"item === 'background_color'\"\n        type=\"background_color\"\n        [presets]=\"presets\"\n      >\n      </ngx-color-picker>\n\n      <!-- seperator -->\n      <div [class]=\"seperatorClass\" *ngIf=\"lastItem && !lastToolbarItem\"></div>\n    </ng-container>\n  </ng-container>\n\n  <!-- custom menu -->\n  <ng-container *ngIf=\"customMenuRef\">\n    <ng-container [ngTemplateOutlet]=\"customMenuRef\"></ng-container>\n  </ng-container>\n</div>\n"
    }]
  }], () => [{
    type: MenuService
  }], {
    toolbar: [{
      type: Input
    }],
    colorPresets: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    editor: [{
      type: Input
    }],
    customMenuRef: [{
      type: Input
    }],
    dropdownPlacement: [{
      type: Input
    }]
  });
})();
class BubbleComponent {
  sanitizeHTML;
  ngxeService;
  constructor(sanitizeHTML, ngxeService) {
    this.sanitizeHTML = sanitizeHTML;
    this.ngxeService = ngxeService;
  }
  get view() {
    return this.editor.view;
  }
  editor;
  updateSubscription;
  execulableItems = [];
  activeItems = [];
  toolbar = [['bold', 'italic', 'underline', 'strike'], ['ordered_list', 'bullet_list', 'blockquote', 'code'], ['align_left', 'align_center', 'align_right', 'align_justify']];
  toggleCommands = ['bold', 'italic', 'underline', 'strike', 'ordered_list', 'bullet_list', 'blockquote', 'code', 'align_left', 'align_center', 'align_right', 'align_justify'];
  getIcon(name) {
    return this.sanitizeHTML.transform(this.ngxeService.getIcon(name));
  }
  getTitle(name) {
    return this.ngxeService.locals.get(name);
  }
  trackByIndex(index) {
    return index;
  }
  onClick(e, commandName) {
    e.preventDefault();
    e.stopPropagation();
    if (e.button !== 0) {
      return;
    }
    const {
      state,
      dispatch
    } = this.view;
    const command = ToggleCommands[commandName];
    command.toggle()(state, dispatch);
  }
  update(view) {
    this.activeItems = [];
    this.execulableItems = [];
    const {
      state
    } = view;
    this.toggleCommands.forEach(toolbarItem => {
      const command = ToggleCommands[toolbarItem];
      const isActive = command.isActive(state);
      if (isActive) {
        this.activeItems.push(toolbarItem);
      }
      const canExecute = command.canExecute(state);
      if (canExecute) {
        this.execulableItems.push(toolbarItem);
      }
    });
  }
  ngOnInit() {
    this.updateSubscription = this.editor.update.subscribe(view => {
      this.update(view);
    });
  }
  ngOnDestroy() {
    this.updateSubscription.unsubscribe();
  }
  static ɵfac = function BubbleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BubbleComponent)(i0.ɵɵdirectiveInject(SanitizeHtmlPipe), i0.ɵɵdirectiveInject(NgxEditorService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: BubbleComponent,
    selectors: [["ngx-bubble"]],
    inputs: {
      editor: "editor"
    },
    features: [i0.ɵɵProvidersFeature([SanitizeHtmlPipe])],
    decls: 1,
    vars: 2,
    consts: [[4, "ngFor", "ngForOf", "ngForTrackBy"], ["type", "button", "class", "NgxBubbleMenu__Icon", 3, "ngClass", "title", "innerHTML", "mousedown", 4, "ngIf"], ["class", "NgxBubbleMenu__Seperator", 4, "ngIf"], ["type", "button", 1, "NgxBubbleMenu__Icon", 3, "mousedown", "ngClass", "title", "innerHTML"], [1, "NgxBubbleMenu__Seperator"]],
    template: function BubbleComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, BubbleComponent_ng_container_0_Template, 2, 2, "ng-container", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.toolbar)("ngForTrackBy", ctx.trackByIndex);
      }
    },
    dependencies: [AsyncPipe, CommonModule, i3.NgClass, i3.NgForOf, i3.NgIf],
    styles: ["*[_ngcontent-%COMP%], *[_ngcontent-%COMP%]:before, *[_ngcontent-%COMP%]:after{box-sizing:border-box}[_nghost-%COMP%]{display:flex;flex-wrap:wrap;background-color:var(--ngx-editor-bubble-bg-color);color:var(--ngx-editor-bubble-text-color);padding:5px;border-radius:4px}.NgxBubbleMenu__Icon[_ngcontent-%COMP%]{all:unset;appearance:none;height:var(--ngx-editor-icon-size);width:var(--ngx-editor-icon-size);transition:.2s ease-in-out;border-radius:var(--ngx-editor-menu-item-border-radius);display:flex;align-items:center;justify-content:center;color:#fff}.NgxBubbleMenu__Icon[_ngcontent-%COMP%]:hover{background-color:var(--ngx-editor-bubble-item-hover-color)}.NgxBubbleMenu__Icon[_ngcontent-%COMP%] + .NgxBubbleMenu__Icon[_ngcontent-%COMP%]{margin-left:5px}.NgxBubbleMenu__Icon.NgxBubbleMenu__Icon--Active[_ngcontent-%COMP%]{background-color:var(--ngx-editor-bubble-text-color);color:var(--ngx-editor-bubble-bg-color)}.NgxBubbleMenu__Seperator[_ngcontent-%COMP%]{border-left:1px solid var(--ngx-editor-seperator-color);margin:0 5px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BubbleComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-bubble',
      imports: [AsyncPipe, CommonModule],
      providers: [SanitizeHtmlPipe],
      template: "<ng-container *ngFor=\"let toolbarItem of toolbar; let lastToolbarItem = last; trackBy: trackByIndex\">\n  <ng-container *ngFor=\"let item of toolbarItem; let lastItem = last; trackBy: trackByIndex\">\n    <button\n      type=\"button\"\n      class=\"NgxBubbleMenu__Icon\"\n      *ngIf=\"toggleCommands.includes(item)\"\n      [ngClass]=\"{\n        'NgxBubbleMenu__Icon--Active': this.activeItems.includes(item),\n        'NgxEditor--Disabled': !this.execulableItems.includes(item)\n      }\"\n      (mousedown)=\"onClick($event, item)\"\n      [title]=\"getTitle(item) | async\"\n      [innerHTML]=\"getIcon(item)\"\n    ></button>\n    <div class=\"NgxBubbleMenu__Seperator\" *ngIf=\"lastItem && !lastToolbarItem\"></div>\n  </ng-container>\n</ng-container>\n",
      styles: ["*,*:before,*:after{box-sizing:border-box}:host{display:flex;flex-wrap:wrap;background-color:var(--ngx-editor-bubble-bg-color);color:var(--ngx-editor-bubble-text-color);padding:5px;border-radius:4px}.NgxBubbleMenu__Icon{all:unset;appearance:none;height:var(--ngx-editor-icon-size);width:var(--ngx-editor-icon-size);transition:.2s ease-in-out;border-radius:var(--ngx-editor-menu-item-border-radius);display:flex;align-items:center;justify-content:center;color:#fff}.NgxBubbleMenu__Icon:hover{background-color:var(--ngx-editor-bubble-item-hover-color)}.NgxBubbleMenu__Icon+.NgxBubbleMenu__Icon{margin-left:5px}.NgxBubbleMenu__Icon.NgxBubbleMenu__Icon--Active{background-color:var(--ngx-editor-bubble-text-color);color:var(--ngx-editor-bubble-bg-color)}.NgxBubbleMenu__Seperator{border-left:1px solid var(--ngx-editor-seperator-color);margin:0 5px}\n"]
    }]
  }], () => [{
    type: SanitizeHtmlPipe
  }, {
    type: NgxEditorService
  }], {
    editor: [{
      type: Input
    }]
  });
})();
class NgxEditorFloatingMenuComponent {
  el;
  constructor(el) {
    this.el = el;
  }
  get display() {
    return {
      visibility: this.showMenu ? 'visible' : 'hidden',
      opacity: this.showMenu ? '1' : '0',
      top: `${this.posTop}px`,
      left: `${this.posLeft}px`
    };
  }
  get view() {
    return this.editor.view;
  }
  editor;
  autoPlace = false;
  posLeft = 0;
  posTop = 0;
  showMenu = false;
  updateSubscription;
  dragging = false;
  resizeSubscription;
  onMouseDown(e) {
    const target = e.target;
    if (this.el.nativeElement.contains(target) && target.nodeName !== 'INPUT') {
      e.preventDefault();
      return;
    }
    this.dragging = true;
  }
  onKeyDown(e) {
    const target = e.target;
    if (target.nodeName === 'INPUT') {
      return;
    }
    this.dragging = true;
    this.hide();
  }
  onMouseUp(e) {
    const target = e.target;
    if (this.el.nativeElement.contains(target) || target.nodeName === 'INPUT') {
      e.preventDefault();
      return;
    }
    this.dragging = false;
    this.useUpdate();
  }
  onKeyUp(e) {
    const target = e.target;
    if (target.nodeName === 'INPUT') {
      return;
    }
    this.dragging = false;
    this.useUpdate();
  }
  useUpdate() {
    if (!this.view) {
      return;
    }
    this.update(this.view);
  }
  hide() {
    this.showMenu = false;
  }
  show() {
    this.showMenu = true;
  }
  async calculateBubblePosition(view) {
    const {
      state: {
        selection
      }
    } = view;
    const {
      from,
      to
    } = selection;
    const start = view.coordsAtPos(from);
    const end = view.coordsAtPos(to);
    const selectionElement = {
      getBoundingClientRect() {
        if (selection instanceof NodeSelection) {
          const node = view.nodeDOM(from);
          return node.getBoundingClientRect();
        }
        const {
          top,
          left
        } = start;
        const {
          bottom,
          right
        } = end;
        return {
          x: left,
          y: top,
          top,
          bottom,
          left,
          right,
          width: right - left,
          height: bottom - top
        };
      }
    };
    // the floating bubble itself
    const bubbleEl = this.el.nativeElement;
    const {
      x: left,
      y: top
    } = await computePosition(selectionElement, bubbleEl, {
      placement: 'top',
      middleware: [offset(5), this.autoPlace && autoPlacement({
        boundary: view.dom,
        padding: 5,
        allowedPlacements: ['top', 'bottom']
      }), {
        // prevent overflow on right and left side
        // since only top and bottom placements are allowed
        // autoplacement can't handle overflows on the right and left
        name: 'overflowMiddleware',
        async fn(middlewareArgs) {
          const overflow = await detectOverflow(middlewareArgs, {
            boundary: view.dom,
            padding: 5
          });
          // overflows left
          if (overflow.left > 0) {
            return {
              x: middlewareArgs.x + overflow.left
            };
          }
          // overflows right
          if (overflow.right > 0) {
            return {
              x: middlewareArgs.x - overflow.right
            };
          }
          return {};
        }
      }].filter(Boolean)
    });
    return {
      left,
      top
    };
  }
  canShowMenu(view) {
    const {
      state
    } = view;
    const {
      selection
    } = state;
    const {
      empty
    } = selection;
    if (selection instanceof NodeSelection) {
      if (selection.node.type.name === 'image') {
        return false;
      }
    }
    const hasFocus = this.view.hasFocus();
    if (!hasFocus || empty || this.dragging) {
      this.hide();
      return false;
    }
    return true;
  }
  update(view) {
    const canShowMenu = this.canShowMenu(view);
    if (!canShowMenu) {
      this.hide();
      return;
    }
    this.calculateBubblePosition(this.view).then(({
      top,
      left
    }) => {
      if (!this.canShowMenu) {
        this.hide();
        return;
      }
      this.posLeft = left;
      this.posTop = top;
      this.show();
    });
  }
  ngOnInit() {
    if (!this.editor) {
      throw new NgxEditorError('Required editor instance to initialize floating menu component');
    }
    this.updateSubscription = this.editor.update.subscribe(view => {
      this.update(view);
    });
    this.resizeSubscription = fromEvent(window, 'resize').pipe(throttleTime(500, asyncScheduler, {
      leading: true,
      trailing: true
    })).subscribe(() => {
      this.useUpdate();
    });
  }
  ngOnDestroy() {
    this.updateSubscription.unsubscribe();
    this.resizeSubscription.unsubscribe();
  }
  static ɵfac = function NgxEditorFloatingMenuComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxEditorFloatingMenuComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NgxEditorFloatingMenuComponent,
    selectors: [["ngx-editor-floating-menu"]],
    hostVars: 2,
    hostBindings: function NgxEditorFloatingMenuComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mousedown", function NgxEditorFloatingMenuComponent_mousedown_HostBindingHandler($event) {
          return ctx.onMouseDown($event);
        }, i0.ɵɵresolveDocument)("keydown", function NgxEditorFloatingMenuComponent_keydown_HostBindingHandler($event) {
          return ctx.onKeyDown($event);
        }, i0.ɵɵresolveDocument)("mouseup", function NgxEditorFloatingMenuComponent_mouseup_HostBindingHandler($event) {
          return ctx.onMouseUp($event);
        }, i0.ɵɵresolveDocument)("keyup", function NgxEditorFloatingMenuComponent_keyup_HostBindingHandler($event) {
          return ctx.onKeyUp($event);
        }, i0.ɵɵresolveDocument);
      }
      if (rf & 2) {
        i0.ɵɵstyleMap(ctx.display);
      }
    },
    inputs: {
      editor: "editor",
      autoPlace: "autoPlace"
    },
    ngContentSelectors: _c3,
    decls: 4,
    vars: 1,
    consts: [["ref", ""], [4, "ngIf"], [3, "editor"]],
    template: function NgxEditorFloatingMenuComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", null, 0);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, NgxEditorFloatingMenuComponent_ng_container_3_Template, 2, 1, "ng-container", 1);
      }
      if (rf & 2) {
        const ref_r2 = i0.ɵɵreference(1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ref_r2.children.length === 0);
      }
    },
    dependencies: [BubbleComponent, CommonModule, i3.NgIf],
    styles: ["*[_ngcontent-%COMP%], *[_ngcontent-%COMP%]:before, *[_ngcontent-%COMP%]:after{box-sizing:border-box}[_nghost-%COMP%]{position:absolute;z-index:20;margin-bottom:5px;visibility:hidden;opacity:0}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxEditorFloatingMenuComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-editor-floating-menu',
      imports: [BubbleComponent, CommonModule],
      template: "<div #ref>\n  <ng-content></ng-content>\n</div>\n<ng-container *ngIf=\"ref.children.length === 0\">\n  <ngx-bubble [editor]=\"editor\"></ngx-bubble>\n</ng-container>\n",
      styles: ["*,*:before,*:after{box-sizing:border-box}:host{position:absolute;z-index:20;margin-bottom:5px;visibility:hidden;opacity:0}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    display: [{
      type: HostBinding,
      args: ['style']
    }],
    editor: [{
      type: Input
    }],
    autoPlace: [{
      type: Input
    }],
    onMouseDown: [{
      type: HostListener,
      args: ['document:mousedown', ['$event']]
    }],
    onKeyDown: [{
      type: HostListener,
      args: ['document:keydown', ['$event']]
    }],
    onMouseUp: [{
      type: HostListener,
      args: ['document:mouseup', ['$event']]
    }],
    onKeyUp: [{
      type: HostListener,
      args: ['document:keyup', ['$event']]
    }]
  });
})();
class MenuModule {
  static ɵfac = function MenuModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MenuModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MenuModule,
    imports: [CommonModule, ReactiveFormsModule,
    // pipes
    SanitizeHtmlPipe,
    // components
    NgxEditorMenuComponent, ToggleCommandComponent, InsertCommandComponent, LinkComponent, DropdownComponent, ImageComponent, ColorPickerComponent, NgxEditorFloatingMenuComponent, BubbleComponent],
    exports: [NgxEditorMenuComponent, NgxEditorFloatingMenuComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [SanitizeHtmlPipe],
    imports: [CommonModule, ReactiveFormsModule,
    // components
    NgxEditorMenuComponent, LinkComponent, DropdownComponent, ImageComponent, ColorPickerComponent, NgxEditorFloatingMenuComponent, BubbleComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule,
      // pipes
      SanitizeHtmlPipe,
      // components
      NgxEditorMenuComponent, ToggleCommandComponent, InsertCommandComponent, LinkComponent, DropdownComponent, ImageComponent, ColorPickerComponent, NgxEditorFloatingMenuComponent, BubbleComponent],
      providers: [SanitizeHtmlPipe],
      exports: [NgxEditorMenuComponent, NgxEditorFloatingMenuComponent]
    }]
  }], null, null);
})();
const NGX_EDITOR_CONFIG_TOKEN = new InjectionToken('NgxEditorConfig');
const defaultConfig = {
  locals: defaults,
  icons
};
class NgxEditorModule {
  static forRoot(config = defaultConfig) {
    return {
      ngModule: NgxEditorModule,
      providers: [{
        provide: NGX_EDITOR_CONFIG_TOKEN,
        useValue: config
      }, {
        provide: NgxEditorServiceConfig,
        useFactory: provideMyServiceOptions,
        deps: [NGX_EDITOR_CONFIG_TOKEN]
      }]
    };
  }
  static forChild(config = defaultConfig) {
    return {
      ngModule: NgxEditorModule,
      providers: [{
        provide: NGX_EDITOR_CONFIG_TOKEN,
        useValue: config
      }, {
        provide: NgxEditorServiceConfig,
        useFactory: provideMyServiceOptions,
        deps: [NGX_EDITOR_CONFIG_TOKEN]
      }, NgxEditorService]
    };
  }
  static ɵfac = function NgxEditorModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxEditorModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: NgxEditorModule,
    imports: [CommonModule, MenuModule, NgxEditorComponent, ImageViewComponent],
    exports: [NgxEditorComponent, NgxEditorMenuComponent, NgxEditorFloatingMenuComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, MenuModule, ImageViewComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxEditorModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, MenuModule, NgxEditorComponent, ImageViewComponent],
      providers: [],
      exports: [NgxEditorComponent, NgxEditorMenuComponent, NgxEditorFloatingMenuComponent]
    }]
  }], null, null);
})();
const isEmptyInputValue = value => {
  // we don't check for string here so it also works with arrays
  return value === null || value.length === 0;
};
const hasValidLength = value => {
  // non-strict comparison is intentional, to check for both `null` and `undefined` values
  return value !== null && typeof value.length === 'number';
};
const isDocEmpty = doc => {
  if (!doc) {
    return true;
  }
  const {
    childCount,
    firstChild
  } = doc;
  return Boolean(childCount === 1 && firstChild?.isTextblock && firstChild.content.size === 0);
};
// @dynamic
class Validators {
  static required(userSchema) {
    return control => {
      const schema$1 = userSchema || schema;
      const doc = parseContent(control.value, schema$1);
      const isEmpty = isDocEmpty(doc);
      if (!isEmpty) {
        return null;
      }
      return {
        required: true
      };
    };
  }
  static maxLength(maxLength, userSchema) {
    return control => {
      const schema$1 = userSchema || schema;
      const doc = parseContent(control.value, schema$1);
      const value = doc.textContent;
      if (hasValidLength(value) && value.length > maxLength) {
        return {
          maxlength: {
            requiredLength: maxLength,
            actualLength: value.length
          }
        };
      }
      return null;
    };
  }
  static minLength(minLength, userSchema) {
    return control => {
      const schema$1 = userSchema || schema;
      const doc = parseContent(control.value, schema$1);
      const value = doc.textContent;
      if (isEmptyInputValue(value) || !hasValidLength(value)) {
        // don't validate empty values to allow optional controls
        // don't validate values without `length` property
        return null;
      }
      if (value.length < minLength) {
        return {
          minlength: {
            requiredLength: minLength,
            actualLength: value.length
          }
        };
      }
      return null;
    };
  }
}
const execMark = (name, toggle = false) => {
  return (state, dispatch) => {
    const command = new Mark(name);
    if (!toggle) {
      return command.apply()(state, dispatch);
    }
    return command.toggle()(state, dispatch);
  };
};
class EditorCommands {
  view;
  state;
  tr;
  constructor(view) {
    if (!view) {
      throw new NgxEditorError('Required view to initialize commands.');
    }
    this.view = view;
    this.state = view.state;
    this.tr = this.view.state.tr;
  }
  applyTrx = tr => {
    this.state = this.state.apply(tr ?? this.tr);
    this.tr = this.state.tr;
    this.tr.setMeta('APPLIED_TRX', true);
  };
  dispatch = tr => {
    this.applyTrx(tr);
  };
  exec() {
    // No changes applied
    if (!this.tr.getMeta('APPLIED_TRX')) {
      return false;
    }
    const forceEmit = !this.view.state.doc.eq(this.state.doc);
    this.view.updateState(this.state);
    const tr = this.tr.setMeta('FORCE_EMIT', forceEmit);
    this.view.dispatch(tr);
    return true;
  }
  focus(position = 'end') {
    const selection = position === 'start' ? Selection.atStart(this.state.doc) : Selection.atEnd(this.state.doc);
    this.tr.setSelection(selection);
    this.applyTrx();
    this.view.focus();
    return this;
  }
  scrollIntoView() {
    this.tr.scrollIntoView();
    this.applyTrx();
    return this;
  }
  insertText(text) {
    this.tr.insertText(text);
    this.applyTrx();
    return this;
  }
  insertNewLine() {
    const newLineCommands = [newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock];
    chainCommands(...newLineCommands)(this.state, this.dispatch);
    return this;
  }
  applyMark(name) {
    execMark(name, false)(this.state, this.dispatch);
    return this;
  }
  toggleMark(name) {
    execMark(name, true)(this.state, this.dispatch);
    return this;
  }
  bold() {
    execMark('strong')(this.state, this.dispatch);
    return this;
  }
  toggleBold() {
    execMark('strong', true)(this.state, this.dispatch);
    return this;
  }
  italics() {
    execMark('em')(this.state, this.dispatch);
    return this;
  }
  toggleItalics() {
    execMark('em', true)(this.state, this.dispatch);
    return this;
  }
  underline() {
    execMark('u')(this.state, this.dispatch);
    return this;
  }
  toggleUnderline() {
    execMark('u', true)(this.state, this.dispatch);
    return this;
  }
  strike() {
    execMark('s')(this.state, this.dispatch);
    return this;
  }
  toggleStrike() {
    execMark('s', true)(this.state, this.dispatch);
    return this;
  }
  code() {
    execMark('code')(this.state, this.dispatch);
    return this;
  }
  toggleCode() {
    execMark('code', true)(this.state, this.dispatch);
    return this;
  }
  superscript() {
    execMark('sup')(this.state, this.dispatch);
    return this;
  }
  subscript() {
    execMark('sub')(this.state, this.dispatch);
    return this;
  }
  toggleOrderedList() {
    const command = new ListItem(false);
    command.toggle()(this.state, this.dispatch);
    return this;
  }
  toggleBulletList() {
    const command = new ListItem(true);
    command.toggle()(this.state, this.dispatch);
    return this;
  }
  toggleHeading(level) {
    const command = new Heading(level);
    command.toggle()(this.state, this.dispatch);
    return this;
  }
  insertLink(text, attrs) {
    const command = new Link$1();
    command.insert(text, attrs)(this.state, this.dispatch);
    return this;
  }
  updateLink(attrs) {
    const command = new Link$1();
    command.update(attrs)(this.state, this.dispatch);
    return this;
  }
  insertImage(src, attrs = {}) {
    const command = new Image$1();
    command.insert(src, attrs)(this.state, this.dispatch);
    return this;
  }
  textColor(color) {
    const command = new TextColor$1('text_color');
    command.apply({
      color
    })(this.state, this.dispatch);
    return this;
  }
  backgroundColor(color) {
    const command = new TextColor$1('text_background_color');
    command.apply({
      backgroundColor: color
    })(this.state, this.dispatch);
    return this;
  }
  removeTextColor() {
    const command = new TextColor$1('text_color');
    command.remove()(this.state, this.dispatch);
    return this;
  }
  removeBackgroundColor() {
    const command = new TextColor$1('text_background_color');
    command.remove()(this.state, this.dispatch);
    return this;
  }
  align(p) {
    const command = new TextAlign(p);
    command.toggle()(this.state, this.dispatch);
    return this;
  }
  insertHTML(html) {
    const {
      selection,
      schema,
      tr
    } = this.state;
    const {
      from,
      to
    } = selection;
    const element = document.createElement('div');
    element.innerHTML = isString(html) ? html.trim() : String(html);
    const slice = DOMParser.fromSchema(schema).parseSlice(element);
    const transaction = tr.replaceRange(from, to, slice);
    this.applyTrx(transaction);
    return this;
  }
  indent() {
    const command = new Indent('increase');
    command.insert()(this.state, this.dispatch);
    return this;
  }
  outdent() {
    const command = new Indent('decrease');
    command.insert()(this.state, this.dispatch);
    return this;
  }
}
const isMacOs = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
// Input rules ref: https://github.com/ProseMirror/prosemirror-example-setup/
// : (NodeType) → InputRule
// Given a blockquote node type, returns an input rule that turns `"> "`
// at the start of a textblock into a blockquote.
const blockQuoteRule = nodeType => {
  return wrappingInputRule(/^\s*>\s$/, nodeType);
};
// : (NodeType) → InputRule
// Given a list node type, returns an input rule that turns a number
// followed by a dot at the start of a textblock into an ordered list.
const orderedListRule = nodeType => {
  return wrappingInputRule(/^(?:\d+)\.\s$/, nodeType, match => ({
    order: Number(match[1])
  }), (match, node) => node.childCount + node.attrs['order'] === Number(match[1]));
};
// : (NodeType) → InputRule
// Given a list node type, returns an input rule that turns a bullet
// (dash, plush, or asterisk) at the start of a textblock into a
// bullet list.
const bulletListRule = nodeType => {
  return wrappingInputRule(/^\s*(?:[-+*])\s$/, nodeType);
};
// : (NodeType) → InputRule
// Given a code block node type, returns an input rule that turns a
// textblock starting with three backticks into a code block.
const codeBlockRule = nodeType => {
  return textblockTypeInputRule(/^```$/, nodeType);
};
// : (NodeType, number) → InputRule
// Given a node type and a maximum level, creates an input rule that
// turns up to that number of `#` characters followed by a space at
// the start of a textblock into a heading whose level corresponds to
// the number of `#` signs.
const headingRule = (nodeType, maxLevel) => {
  return textblockTypeInputRule(new RegExp(`^(#{1,${maxLevel}})\\s$`), nodeType, match => ({
    level: match[1].length
  }));
};
// : (MarkType) → InputRule
// Wraps matching text with bold mark
const boldRule = markType => {
  // eslint-disable-next-line prefer-named-capture-group
  return markInputRule(/(?:^|\s)(?:(\*\*|__)(?:([^*_]+))(\*\*|__))$/, markType);
};
// : (MarkType) → InputRule
// Wraps matching text with em mark
const emRule = markType => {
  // eslint-disable-next-line prefer-named-capture-group
  return markInputRule(/(?:^|\s)(?:(\*|_)(?:([^*_]+))(\*|_))$/, markType);
};
// : (Schema) → Plugin
// A set of input rules for creating the basic block quotes, lists,
// code blocks, and heading.
const buildInputRules = schema => {
  const rules = smartQuotes.concat(ellipsis, emDash);
  rules.push(boldRule(schema.marks['strong']));
  rules.push(emRule(schema.marks['em']));
  rules.push(blockQuoteRule(schema.nodes['blockquote']));
  rules.push(orderedListRule(schema.nodes['ordered_list']));
  rules.push(bulletListRule(schema.nodes['bullet_list']));
  rules.push(codeBlockRule(schema.nodes['code_block']));
  rules.push(headingRule(schema.nodes['heading'], 6));
  return inputRules({
    rules
  });
};
const getKeyboardShortcuts = (schema, options) => {
  const historyKeyMap = {};
  historyKeyMap['Mod-z'] = undo$1;
  if (isMacOs) {
    historyKeyMap['Shift-Mod-z'] = redo$1;
  } else {
    historyKeyMap['Mod-y'] = redo$1;
  }
  const plugins = [keymap({
    'Mod-b': toggleMark(schema.marks['strong']),
    'Mod-i': toggleMark(schema.marks['em']),
    'Mod-u': toggleMark(schema.marks['u']),
    'Mod-`': toggleMark(schema.marks['code'])
  }), keymap({
    'Enter': splitListItem(schema.nodes['list_item']),
    'Shift-Enter': chainCommands(exitCode, (state, dispatch) => {
      const {
        tr
      } = state;
      const br = schema.nodes['hard_break'];
      dispatch(tr.replaceSelectionWith(br.create()).scrollIntoView());
      return true;
    }),
    'Mod-[': liftListItem(schema.nodes['list_item']),
    'Mod-]': sinkListItem(schema.nodes['list_item']),
    'Tab': sinkListItem(schema.nodes['list_item'])
  }), keymap(baseKeymap)];
  if (options.history) {
    plugins.push(keymap(historyKeyMap));
  }
  return plugins;
};
const getDefaultPlugins = (schema, options) => {
  const plugins = [];
  if (options.keyboardShortcuts) {
    plugins.push(...getKeyboardShortcuts(schema, {
      history: options.history
    }));
  }
  if (options.history) {
    plugins.push(history());
  }
  if (options.inputRules) {
    plugins.push(buildInputRules(schema));
  }
  return plugins;
};
const defaultFeatures = {
  linkOnPaste: true,
  resizeImage: true
};
const DEFAULT_OPTIONS = {
  content: null,
  history: true,
  keyboardShortcuts: true,
  inputRules: true,
  schema: schema,
  plugins: [],
  nodeViews: {},
  attributes: {},
  features: defaultFeatures,
  handleScrollToSelection: null,
  linkValidationPattern: '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/??([^#\n\r]*)?#?([^\n\r]*)|(mailto:.*[@].*)'
};
class Editor {
  options;
  view;
  constructor(options = DEFAULT_OPTIONS) {
    this.options = {
      ...DEFAULT_OPTIONS,
      ...options
    };
    this.createEditor();
  }
  valueChangesSubject = new Subject();
  updateSubject = new Subject();
  get valueChanges() {
    return this.valueChangesSubject.asObservable();
  }
  get update() {
    return this.updateSubject.asObservable();
  }
  get schema() {
    return this.options.schema || schema;
  }
  get linkValidationPattern() {
    return this.options.linkValidationPattern;
  }
  get commands() {
    return new EditorCommands(this.view);
  }
  get features() {
    return {
      ...defaultFeatures,
      ...this.options.features
    };
  }
  handleTransactions(tr) {
    const state = this.view.state.apply(tr);
    this.view.updateState(state);
    this.updateSubject.next(this.view);
    if (!tr.docChanged && !tr.getMeta('FORCE_EMIT')) {
      return;
    }
    const json = state.doc.toJSON();
    this.valueChangesSubject.next(json);
  }
  createEditor() {
    const {
      options,
      schema
    } = this;
    const {
      content = null,
      nodeViews
    } = options;
    const {
      history = true,
      keyboardShortcuts = true,
      inputRules = true
    } = options;
    const doc = parseContent(content, schema, options.parseOptions);
    const plugins = options.plugins ?? [];
    const attributes = options.attributes ?? {};
    const defaultPlugins = getDefaultPlugins(schema, {
      history,
      keyboardShortcuts,
      inputRules
    });
    this.view = new EditorView(null, {
      state: EditorState.create({
        doc,
        schema,
        plugins: [...defaultPlugins, ...plugins]
      }),
      nodeViews,
      dispatchTransaction: this.handleTransactions.bind(this),
      attributes,
      handleScrollToSelection: options.handleScrollToSelection
    });
  }
  setContent(content) {
    if (isNil(content)) {
      return;
    }
    const {
      state
    } = this.view;
    const {
      tr,
      doc
    } = state;
    const newDoc = parseContent(content, this.schema, this.options.parseOptions);
    tr.replaceWith(0, state.doc.content.size, newDoc);
    // don't emit if both content is same
    if (doc.eq(tr.doc)) {
      return;
    }
    if (!tr.docChanged) {
      return;
    }
    this.view.dispatch(tr);
  }
  registerPlugin(plugin) {
    const {
      state
    } = this.view;
    const plugins = [...state.plugins, plugin];
    const newState = state.reconfigure({
      plugins
    });
    this.view.updateState(newState);
  }
  destroy() {
    this.view.destroy();
  }
}

/*
 * Public API Surface of ngx-editor
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DEFAULT_TOOLBAR, Editor, ImageViewComponent, NGX_EDITOR_CONFIG_TOKEN, NgxEditorComponent, NgxEditorFloatingMenuComponent, NgxEditorMenuComponent, NgxEditorModule, NgxEditorService, TOOLBAR_FULL, TOOLBAR_MINIMAL, Validators, emptyDoc, getKeyboardShortcuts, parseContent, provideMyServiceOptions, toDoc, toHTML };
